// angular
import { Injectable } from "@angular/core";
// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";
// global-services

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

// order-entry services
import { OECoordinatorService } from "../oe-coordinator.service";
import { OEModelGetterService } from "../model/oe-model-getter.service";
import { OEModelSetterService } from "../model/oe-model-setter.service";
import { OEInputModel } from "../../data/models/oe-input.model";
import { OEValidatorService } from "../oe-validator.service";
import { OENCommand } from "../../data/enums/oe-command.enum";
import { OENOperationMode } from "../../data/enums/oe-operation-mode.enum";
import {
  ICAutocompleteGenericModel,
  ICTenorValueDateModel,
  ICMarkupModel,
  ICFixingSourceModel,
  ICTimeControlModel,
} from "../../interface/controls/models/bfx-interface-controls.models";
import { OENInputControl } from "../../data/enums/oe-input-control.enum";
import { OENPanel } from "../../data/enums/oe-panel.enum";
import { OEUtilityService } from "../basic/oe-utility.service";
import { OELoggerService } from "../basic/oe-logger.service";
import { OELookupService } from "../basic/oe-lookup.service";
import { NOSECS_VALIDATE_TIME_PATTERN } from "../../interface/controls/bfx-time-input.component";
import { OETimeMachineService } from "../basic/oe-time-machine.service";
import { OENLockedState } from "../../data/enums/oe-locked-state.enum";
import { OESettingsService } from "../basic/oe-settings.service";
import { OEDatasetService } from "../basic/oe-dataset.service";
import { ICLimitPriceModel } from "../../interface/controls/models/ic-limit-price.model";
import { OENEntryType } from "../../data/enums/oe-entry-type.enum";
import { ATDLParameterDataModel } from "../../data-atdl/model/atdl-parameter-data.model";
import { ICDBaseModel } from "../../data-idc/controls/icd-base.model";
import { ATDLNParameterType } from "../../data-atdl/enums/atdl-parameter-type.enum";
import { OEDataModel } from "../../data/models/oe-data.model";
import { ICDAuxCheckboxModel } from "../../data-idc/controls/icd-aux-checkbox.model";
import { ICDAutocompleteModel } from "../../data-idc/controls/icd-autocomplete.model";
import { ATDLEnumModel } from "../../data-atdl/model/atdl-enum.model";
import { ICDTransportModel } from "../../data-idc/coordination/icd-transport.model";
import { ICDCheckboxModel } from "../../data-idc/controls/icd-checkbox.model";
import { ICD_CLOCK_TIME_PATTERN, ICD_TZ_CLOCK_TIME_PATTERN } from "../atdl/atdl-utility.service";
import { ICDRadioInputModel } from "../../data-idc/controls/icd-radio-input.model";
import { ICDNAuxMode } from "../../data-idc/enums/icd-aux-mode.enum";
import { ATDLDatasetService } from "../atdl/atdl-dataset.service";
import { TRADING_SOURCE_INTERNAL } from "shared/cubiq-services/model/TradingSource.constants";
import { OEStrategyModel } from "../../data/models/oe-strategy.model";
import { INFO_RUNGS_MID } from "shared/cubiq-model-multi-asset/model/impl/GammaOrderRequestImpl";
import { OEPanelGammaViewModel } from "app/order-entry/data/models/oe-panel-gamma-view.model";
import { OEPanelGammaLeg } from "app/order-entry/data/models/oe-panel-gamma-leg.model";
import {
  SUSPENSION_PARAM_TYPE,
  VALID_FROM_TIME,
  VALID_FROM_TIMEZONE,
  VALID_TO_TIME,
  VALID_TO_TIMEZONE,
} from "shared/cubiq-services/model/orders/SuspensionHelper";
import { ICDSpinnerModel } from "app/order-entry/data-idc/controls/icd-spinner.model";
import { MarkupCriteria } from "../../../../shared/cubiq-services";
import { ConstraintValue } from "../../../../shared/cubiq-services/model/core/ConstraintValue";

@Injectable()
export class OEAdapterForwardService {
  /**********************************************************************/
  readonly DATE_FORMAT: string = "YYYY-MM-DD";

  /**********************************************************************/
  /* CONSTRUCTOR  */
  constructor(
    private oeLogger: OELoggerService,
    private coordinator: OECoordinatorService,
    private getter: OEModelGetterService,
    private setter: OEModelSetterService,
    private validator: OEValidatorService,
    private utility: OEUtilityService,
    private lookup: OELookupService,
    private timeMachine: OETimeMachineService,
    private settings: OESettingsService,
    private atdlDataset: ATDLDatasetService,
    private oeLookup: OELookupService,
    private datasetService: OEDatasetService,
  ) {
    this.oeLogger = oeLogger.for(__dirname);
  }

  /**********************************************************************/
  /* Create NEW/DUPLICATE/MODIFY Request  */
  public createOrderEntryRequest(
    rootRefId: string,
    errorsMap: Map<string, Array<OEInputModel>>,
  ): boolean {
    try {
      if (errorsMap == null) errorsMap = new Map<string, Array<OEInputModel>>();
      // get root node model
      let realRootRefId: string = rootRefId;
      if (!this.getter.isRootNode(rootRefId)) {
        // if not root
        realRootRefId = this.getter.getRootIdForNodeWithRefId(rootRefId); // find the root id
      }
      if (this.getter.isBenchmarkRequest(rootRefId)) {
        // BMARK
        // BENCHMARK ORDER

        let errors: Array<OEInputModel> = Array<OEInputModel>();
        if (
          this.prepareBmarkOrderRequestData(
            rootRefId,
            errors,
            this.getter.getOperationMode(rootRefId),
          )
        ) {
          return true;
        } else {
          errorsMap.set(rootRefId, errors);
          return false;
        }
      } else if (this.getter.isGammaStrategy(realRootRefId)) {
        let errorsOrderData: Array<OEInputModel> = Array<OEInputModel>();
        let rootOrderData: CubiqTS.OrderRequestDataImpl = new CubiqTS.OrderRequestDataImpl();
        if (this.prepareOrderRequestData(realRootRefId, rootOrderData, errorsOrderData)) {
          let errorsLinkedOrder: Array<OEInputModel> = Array<OEInputModel>();
          if (this.prepareGammaOrderRequest(realRootRefId, rootOrderData, errorsLinkedOrder)) {
            //jmh
            return true; // LinkedOrder request can be submitted, attached on the model
          } else {
            errorsMap.set(realRootRefId, errorsLinkedOrder);
            return false;
          }
        } else {
          errorsMap.set(realRootRefId, errorsOrderData);
          return false;
        }
      } else if (this.getter.isRootNodeAlone(realRootRefId)) {
        // single order (only root node)
        //let rootModel: BfxOrderEntryDataModel =  this.getter.get(realRootRefId);
        //this.config.debug ? logger.out.info("-------------------- SUBMIT DUMP ------------------------"): '';
        //----------------------------------------------------------- ORDER WITHOUT STRATEGY LEGS - ROOT ONLY
        // root node is alone in the strategy graph
        let errorsOrderData: Array<OEInputModel> = Array<OEInputModel>();
        let rootOrderData: CubiqTS.OrderRequestDataImpl = new CubiqTS.OrderRequestDataImpl();
        if (this.prepareOrderRequestData(realRootRefId, rootOrderData, errorsOrderData)) {
          let errorsLinkedOrder: Array<OEInputModel> = Array<OEInputModel>();
          if (this.prepareLinkedOrderRequest(realRootRefId, rootOrderData, errorsLinkedOrder)) {
            return true; // LinkedOrder request can be submitted, attached on the model
          } else {
            errorsMap.set(realRootRefId, errorsLinkedOrder);
            return false;
          }
        } else {
          errorsMap.set(realRootRefId, errorsOrderData);
          return false;
        }
        //----------------------------------------------------------- ORDER WITH STRATEGY LEGS - MULTIPLE NODES
        // The strategy order has multiple (at least 2) nodes
      } else if (this.getter.hasStrategy(realRootRefId)) {
        let nodeIds: Array<string> = this.getter.getStrategyNodesListRoot(realRootRefId);
        let nodeModelsMap: Map<string, CubiqTS.OrderRequestDataImpl> = new Map<
          string,
          CubiqTS.OrderRequestDataImpl
        >();
        let errorsFg = false;
        // prepare OrderRequests
        nodeIds.forEach((refId: string) => {
          let errors: Array<OEInputModel> = Array<OEInputModel>();
          let orderData: CubiqTS.OrderRequestDataImpl = new CubiqTS.OrderRequestDataImpl();
          if (this.prepareOrderRequestData(refId, orderData, errors)) {
            nodeModelsMap.set(refId, orderData);
          } else {
            errorsFg = true;
            errorsMap.set(refId, errors);
          }
        });

        if (errorsFg && errorsMap.size > 0) {
          // error notifications moved one level up
          return false;
        }

        // prepare linked relationships
        nodeIds.forEach((refId) => {
          let model = this.getter.get(refId);
          let orderData = nodeModelsMap.get(refId);
          if (this.getter.hasStrategy(refId)) {
            // children
            if (model.strategy.children.length > 0) {
              orderData.childRelationships = new Array<CubiqTS.LinkedRelationshipImpl>();
              model.strategy.children.forEach((childRelationship) => {
                let relationshipModel = new CubiqTS.LinkedRelationshipImpl();
                relationshipModel.parentId = refId;
                relationshipModel.relationshipType = childRelationship.type;
                let relationshipOrderData = nodeModelsMap.get(childRelationship.refId);
                if (relationshipOrderData != null) {
                  relationshipModel.order = relationshipOrderData;
                  orderData.childRelationships.push(relationshipModel);
                } else {
                  logger.out.error(
                    `ERROR:_oeWorker.createOrderDataStructure(): Child relationship model with refId: "${realRootRefId}" not found!`,
                  );
                  errorsFg = true;
                }
              });
            }
            // siblings
            if (model.strategy.siblings.length > 0) {
              // only one sibling possible
              model.strategy.siblings.forEach((siblingRelationship) => {
                let legOrderEntryDataModel = this.getter.get(siblingRelationship.refId);
                if (legOrderEntryDataModel.strategy.parentRefId === model.refId) {
                  // add sibling only if current model is parent
                  let relationshipModel = new CubiqTS.LinkedRelationshipImpl();
                  relationshipModel.parentId = refId;
                  relationshipModel.relationshipType = siblingRelationship.type;
                  let relationshipOrderData = nodeModelsMap.get(siblingRelationship.refId);
                  if (relationshipOrderData != null) {
                    relationshipModel.order = relationshipOrderData;
                    orderData.sibling = relationshipModel;
                  } else {
                    logger.out.error(
                      `ERROR:_oeWorker.createOrderDataStructure(): Child relationship model with refId: "${realRootRefId}" not found!`,
                    );
                    errorsFg = true;
                  }
                }
              });
            }
          }
        });

        if (errorsFg) {
          logger.out.error(
            `ERROR:_oeWorker.createOrderDataStructure(): Errors while composing strategy structure for root node with refId: "${realRootRefId}" `,
          );
          this.coordinator.cmdChangeDisplayState(
            realRootRefId,
            OENCommand.STATE_ORDER_INT_ERROR,
            "Internal error: Strategy composition fail!",
          );
          return false;
        }

        let errorsLinkedOrder: Array<OEInputModel> = Array<OEInputModel>();
        let rootOrderData: CubiqTS.OrderRequestDataImpl = nodeModelsMap.get(realRootRefId);
        if (this.prepareLinkedOrderRequest(realRootRefId, rootOrderData, errorsLinkedOrder)) {
          return true; // LinkedOrder request can be submitted, attached on the model
        } else {
          errorsMap.set(realRootRefId, errorsLinkedOrder);
          return false;
        }
      } else {
        // error
        logger.out.error(
          `ERROR:_oeWorker.createOrderDataStructure(): Model with refId: "${realRootRefId}" is invalid!`,
        );
      }
    } catch (ex) {
      logger.out.error(`EXCEPTION:_oeWorker.createOrderDataStructure(): %O`, ex);
      this.coordinator.cmdChangeDisplayState(
        rootRefId,
        OENCommand.STATE_ORDER_INT_ERROR,
        "Internal error: exception = " + ex,
      );
      return false;
    }
  }

  /**********************************************************************/
  /**
   * This function takes the order data for the root node (with the entire strategy leg structure in it) and creates LinkedOrderRequestImpl or LinkedOrderModificationRequestImpl which is
   * then attached to the root node Order Data model
   * @param rootRefId - this is the refId of the root node
   * @param rootOrderData -
   */
  protected prepareLinkedOrderRequest(
    rootRefId: string,
    rootOrderData: CubiqTS.OrderRequestDataImpl,
    errors: Array<OEInputModel> = null,
  ): boolean {
    try {
      // Order Entry Data Model - Interface
      let rootModel = this.getter.get(rootRefId);
      // Order Request models
      let requestModel = this.defineRequestModel(rootModel);
      if (requestModel != null) {
        // Errors init
        if (errors == null) {
          errors = new Array<OEInputModel>();
        }

        requestModel.client = this.extractClient(rootModel, errors);
        requestModel.account = this.extractAccount(rootModel, errors);
        requestModel.oboClient = this.extractOBOClient(rootModel, errors);
        requestModel.oboAccount = this.extractOBOAccount(rootModel, errors);
        requestModel.clientTrader = this.extractClientTrader(rootModel, errors); // client trader - not mandatory
        // Request model
        requestModel.rootOrder = rootOrderData;
        requestModel.oboUser = rootModel.oboUser;

        /// Link reference
        if (rootModel.operationMode === OENOperationMode.MODIFY) {
          requestModel.linkReference = rootRefId;
        } else {
          requestModel.linkReference = this.utility.generateRandomRefId();
        }

        /* MODEL ASSIGNMENT  */
        if (errors.length === 0) {
          // no input data errors
          rootModel.requestModel = requestModel;
          //this.outputExtendedLogging(`UI-MAIN: OrderEntry@${Date.now()}: SUBMIT Root -> RefId: ${rootModel.refId} | OrderId: ${rootModel.orderId}`);// | ROOT Dump: %O`, rootModel.requestModel);
          return true;
        } else {
          // input data errors
          rootModel.requestModel = null;
          this.setter.reportValidationErrors(rootModel.refId);
          this.outputExtendedLogging(
            `INFO: SUBMIT Root -> RefId: ${rootModel.refId} | OrderId: ${rootModel.orderId} | errors: %O`,
            errors,
          );
          return false;
        }
      } else {
        return false;
      }
    } catch (ex) {
      logger.out.error(`EXCEPTION:_oeWorker.prepareLinkedOrderRequest(): %O`, ex);
      this.coordinator.cmdChangeDisplayState(
        rootRefId,
        OENCommand.STATE_ORDER_INT_ERROR,
        "Internal error: exception = " + ex,
      );
      return false;
    }
  }

  /**********************************************************************/

  protected prepareOrderRequestData(
    refId: string,
    requestOrderData: CubiqTS.OrderRequestDataImpl = null,
    errors: Array<OEInputModel>,
  ): boolean {
    try {
      // Order Entry Data Model - Interface
      let model = this.getter.get(refId);
      this.oeLogger.outputDevLogToConsole(
        `INFO: Prepare Request -> RefId: ${model.refId} | OEDataModel: `,
        false,
        model,
      );
      //  Order Entry Data Model - Server request
      if (
        requestOrderData instanceof CubiqTS.OrderRequestDataImpl &&
        model instanceof OEDataModel
      ) {
        // reset previously reported errors
        this.setter.resetValidationErrors(refId);

        // CLIENT
        requestOrderData.clientCode = this.extractClient(model, errors);
        // ACCOUNT
        requestOrderData.accountCode = this.extractAccount(model, errors);
        // CCY PAIR
        requestOrderData.base = this.extractCcyPairBase(model, errors);
        requestOrderData.nonBase = this.extractCcyPairNonBase(model, errors);
        // ORDER TYPE
        requestOrderData.requestOrderType = this.extractRequestOrderType(model, errors);
        requestOrderData.orderType = this.extractOrderType(model, errors);
        // AMOUNT
        requestOrderData.fixedAmount = this.extractFixedAmount(model, errors);
        // CLIENT INTENT
        requestOrderData.clientIntent = this.extractClientIntent(model, errors);
        // FIXED CCY
        requestOrderData.fixedCcy = this.extractFixedCCY(model, errors);
        // REQUEST RATE
        requestOrderData.requestRate = this.extractRequestRate(model, errors);
        // TRAILING PIPS
        requestOrderData.tslDistancePips = this.extractTrailingPips(model, errors);
        // TRAILING TRIGGER
        requestOrderData.tslStartRate = this.extractTrailingTrigger(model, errors);
        // ALLOW PARTIAL FILLS / FILL SUPPORT
        requestOrderData.fillSupport = this.extractAllowPartialFills(model);
        // CONTACTS
        requestOrderData.clientContacts = this.extractContacts(model);
        // HOLD STP
        requestOrderData.stpHold = this.extractHoldSTP(model);
        // PRIVATE ORDER
        requestOrderData.isPrivateOrder = this.extractPrivateOrder(model);
        // EXECUTION MODE
        requestOrderData.fillTypeRestriction = this.extractExecutionMode(model);
        // TRADER GROUP
        requestOrderData.traderGroup = this.extractTraderGroup(model, errors);
        // CLIENT COMMENT
        requestOrderData.comment = this.extractComment1(model);
        // PRIVATE COMMENT
        requestOrderData.comment2 = this.extractComment2(model);
        // PRODUCT
        requestOrderData.product = this.extractProduct(model);
        // TRIGGER
        requestOrderData.forwardTrackingType = this.extractTrigger(model, errors);
        // OBO CLIENT
        requestOrderData.oboClient = this.extractOBOClient(model, errors);
        // OBO Account
        requestOrderData.oboAccount = this.extractOBOAccount(model, errors);
        // Custom Field Values
        requestOrderData.customValues = model.customValues;
        // Order Ref
        requestOrderData.orderRef = this.extractOrderRef(model, errors);

        /////////// Extraction with assignment
        // VALUE DATE
        this.assignValueDate(this.extractValueDate(model, errors), requestOrderData);
        // MARKUP
        this.extractAndAssignMarkup(model, requestOrderData, errors);
        // SUSPEND
        this.extractAndAssignSuspend(model, requestOrderData, errors);
        // GOOD FROM - UNTIL
        this.extractAndAssignGoodFromUntil(model, requestOrderData, errors);
        // CUSTOM FIELDS
        this.processCustomFields(model, requestOrderData, errors);

        /*** NDF ONLY ***/
        if (model.entryType === OENEntryType.NDF) {
          // FIXING SOURCE (NDF only)
          requestOrderData.fixingSource = this.extractFixingSource(model, errors);
          // FIXING DATE (NDF Only)
          if (model.fixingDate != null) {
            requestOrderData.fixingDate = this.extractFixingDate(model, errors);
          }
        }

        /*** ALGO ONLY ***/
        if (this.isAlgoOrder(model)) {
          // ALGO DATA
          if (!Array.isArray(requestOrderData.strategyParameters)) {
            requestOrderData.strategyParameters = new Array<CubiqTS.StrategyParameterImpl>();
          }
          // ALGO TYPE
          let spAlgoType: CubiqTS.StrategyParameterImpl = this.extractAlgoType(model, true, errors);
          if (spAlgoType instanceof CubiqTS.StrategyParameterImpl) {
            // algo type is defined
            requestOrderData.strategyParameters.push(spAlgoType);
            // Limit Price
            let limitPrice = this.extractAlgoLimitPrice(model, errors);
            if (typeof limitPrice === "string") {
              requestOrderData.requestRate = limitPrice;
            }
            // Strategy Parameters
            let strategyParameters: Array<CubiqTS.StrategyParameterImpl> =
              this.extractAlgoParameters(model, limitPrice, errors);
            if (Array.isArray(strategyParameters) && strategyParameters.length > 0) {
              requestOrderData.strategyParameters =
                requestOrderData.strategyParameters.concat(strategyParameters);
            }
          }

          // Forward algos are always spot tracked
          requestOrderData.forwardTrackingType = CubiqTS.RequestTrackingType.SPOT_RATE;

          requestOrderData.autoForwardPricing = model.autoForwardPrice;
        }

        /*** MODIFY ONLY ***/
        if (model.operationMode === OENOperationMode.MODIFY) {
          // ORDER ID
          requestOrderData.orderId = model.orderId;
          // PASS THROUGH PARAMETERS
          requestOrderData.passthroughParameters = model.passthroughParameters;
        }

        // STP Aggregation Flag
        requestOrderData.stpAggregationEnabled = this.extractStpAgg(requestOrderData, model);

        /*  HARDCODED DATA */
        requestOrderData.externalClientReference = this.extractExternalReference(model);
        requestOrderData.tradingChannel = TRADING_SOURCE_INTERNAL;
        requestOrderData.useDefaultClientDataFg = false;

        this.cleanupRequestOrderData(requestOrderData);
        /* MODEL ASSIGNMENT  */
        if (errors.length === 0) {
          // no input data errors
          logger.out.info(
            `UI-MAIN: SUBMIT Node -> RefID: ${model.refId} | OrderID: ${model.orderId} => Request Model VALID`,
          ); // | NODE Model: `, orderData)
          return true;
        } else {
          // input data errors
          logger.out.info(
            `UI-MAIN: SUBMIT Node -> RefID: ${model.refId} | OrderID: ${model.orderId} => Request Model INVALID`,
          );
          this.oeLogger.outputInputControlErrors(refId, errors, "On SUBMIT");
          this.setter.reportValidationErrors(refId);
          return false;
        }
      } else {
        this.coordinator.cmdChangeDisplayState(
          refId,
          OENCommand.STATE_ORDER_INT_ERROR,
          "Internal error: Invalid data or request model",
        );
        return false;
      }
    } catch (ex) {
      logger.out.error(`EXCEPTION: oeForwardAdapter.prepareOrderRequest(): %O`, ex);
      this.coordinator.cmdChangeDisplayState(
        refId,
        OENCommand.STATE_ORDER_INT_ERROR,
        "Internal error: exception = " + ex,
      );
      return false;
    }
  }
  private extractStpAgg(requestOrderData: CubiqTS.OrderRequestDataImpl, model: OEDataModel) {
    if (
      this.settings.isSTPAggAvailable(
        requestOrderData.requestOrderType,
        requestOrderData.fillSupport,
      )
    ) {
      return ConstraintValue.isEnabled(model.stpAggregationFlag);
    }

    return false;
  }

  /**
   * Independently create the Algo parameters array without requiring requestOrderData. SHould be integrated above eventually
   * @param model
   * @param errors
   * @returns
   */
  public createAlgoStrategyParameters(
    model: OEDataModel,
    errors: OEInputModel[],
    existingParameters?: Array<CubiqTS.StrategyParameterImpl>,
  ): Array<CubiqTS.StrategyParameterImpl> {
    /*** ALGO ONLY ***/
    let retParameters: Array<CubiqTS.StrategyParameterImpl> = existingParameters ?? [];
    if (this.isAlgoOrder(model)) {
      // ALGO TYPE
      let spAlgoType: CubiqTS.StrategyParameterImpl = this.extractAlgoType(model, false, errors);
      if (spAlgoType instanceof CubiqTS.StrategyParameterImpl) {
        // algo type is defined
        retParameters.push(spAlgoType);
        // Limit Price - will not work without an assoicated limitMode
        let limitPrice = "limitPrice"; //this.extractAlgoLimitPrice(model, errors);
        // Strategy Parameters
        let strategyParameters: Array<CubiqTS.StrategyParameterImpl> = this.extractAlgoParameters(
          model,
          limitPrice,
          errors,
        );
        if (Array.isArray(strategyParameters) && strategyParameters.length > 0) {
          retParameters = retParameters.concat(strategyParameters);
        }
      }
    }
    return retParameters;
  }

  public createMarkupCriteria(model: OEDataModel): MarkupCriteria {
    let criteria: MarkupCriteria = new MarkupCriteria();

    criteria.account = model.account.id;
    criteria.clientCd = model.client.clientId;
    criteria.fixedCcy = model.fixedCcy.ccy;

    let precision: number;
    if (model.ccyPair != model.ccyPairModel.base + model.ccyPairModel.nonBase) {
      criteria.nonBase = model.ccyPairModel.base;
      criteria.base = model.ccyPairModel.nonBase;
      precision = model.ccyPairModel.limitEntrySpotInvertDecimals;
    } else {
      criteria.base = model.ccyPairModel.base;
      criteria.nonBase = model.ccyPairModel.nonBase;
      precision = model.ccyPairModel.limitEntrySpotDecimals;
    }
    criteria.clientBuysFixed = model.clientIntent === CubiqTS.OrderIntent.BUY;
    criteria.requestOrderType = model.orderType.value;
    criteria.product = this.extractProduct(model);

    if (criteria.product === CubiqTS.Product.SWP || criteria.product === CubiqTS.Product.SSP) {
      criteria.tenor = CubiqTS.Tenor.SPOT;
    } else {
      this.assignValueDate(this.extractValueDate(model, []), criteria);
    }

    criteria.tradingSource = TRADING_SOURCE_INTERNAL;
    if (model.requestPrice !== null) {
      criteria.requestRate = model.requestPrice.toFixed(precision);
    }
    if (model.orderAmount !== null) {
      criteria.orderAmount = model.orderAmount.toString();
    }

    if (model.fixingCode) {
      if (model.fixingCode != null && model.fixingCode) {
        criteria.benchmarkCode = model.fixingCode;
      }
      if (model.fixingDate) {
        let dateFormat: string = "DD-MMM-YYYY";
        let formattedDate: string = CubiqTS.moment(model.fixingDate).format(dateFormat);

        criteria.benchmarkDts = this.timeMachine.createMoment4StringArray(
          formattedDate,
          model.fixingTime.substring(0, 2) + ":" + model.fixingTime.substring(2, 4),
          model.fixingTimezone,
        );
      }
    }

    if (model.algoType?.value) {
      criteria.algoStrategyName = model.algoType.value;
    }
    return criteria;
  }

  /**********************************************************************/
  /* BENCHMARK Entry Request  [FixingOrderRequestDataImpl]   */

  public prepareBmarkOrderRequestData(
    refId: string,
    errors: Array<OEInputModel>,
    mode: OENOperationMode = OENOperationMode.NEW,
    requestOrderData = new CubiqTS.FixingOrderRequestDataImpl(),
    ignoreErrorSet: Set<string> = new Set(),
    asPartOfBulk: boolean = false,
  ): boolean {
    try {
      logger.out.info("oea-fwd-s - Prepraring BM request");
      let model: OEDataModel = this.getter.get(refId);

      this.setter.resetValidationErrors(refId);

      // CCY PAIR
      if (
        model.ccyPair != null &&
        typeof model.ccyPair === "string" &&
        model.ccyPairModel != null &&
        model.ccyPairModel instanceof CubiqTS.CurrencyPairImpl
      ) {
        requestOrderData.base = model.ccyPair.substr(0, 3);
        requestOrderData.nonBase = model.ccyPair.substr(3, 3);
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.CCY_PAIR));
      }

      requestOrderData.orderType = CubiqTS.OrderType.BENCHMARK;
      requestOrderData.requestOrderType = CubiqTS.RequestOrderType.BMARK;
      this.assignValueDate(this.extractValueDate(model, errors), requestOrderData);
      requestOrderData.product = this.extractProduct(model);

      requestOrderData.orderId = model.orderId;
      requestOrderData.externalClientReference = this.extractExternalReference(model);
      requestOrderData.fixedAmount = this.extractFixedAmount(model, errors);
      requestOrderData.clientIntent = this.extractClientIntent(model, errors);
      requestOrderData.fixedCcy = this.extractFixedCCY(model, errors);
      requestOrderData.traderGroup = this.extractTraderGroup(model, errors);
      requestOrderData.fixingSource = this.extractFixingCode(model, errors);
      requestOrderData.fwdNettingId = model.fwdNettingId;
      requestOrderData.stpHold = this.extractHoldSTP(model);
      requestOrderData.autoForwardPricing = this.extractAutoFwdPrice(model);

      if (this.isValidMarkup(model)) {
        requestOrderData.markup = this.extractMarkup(model);
        requestOrderData.markupType = this.extractMarkupType(model);
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.MARKUP));
      }

      requestOrderData.fixingDate = this.extractFixingDate(model, errors);
      requestOrderData.fixingTime = this.extractFixingTime(model, errors);

      let request: CubiqTS.FixingOrderRequest = null;
      if (mode == OENOperationMode.MODIFY || mode == OENOperationMode.MODIFY_INFO) {
        request = new CubiqTS.FixingOrderModificationRequestImpl();
        if (model.isModificationPrivatized) {
          (request as CubiqTS.FixingOrderModificationRequestImpl).privatisedRequest = true;
        }
      } else {
        request = new CubiqTS.FixingOrderRequestImpl();
      }
      request.fixingOrderData = requestOrderData;
      request.oboUser = model.oboUser;

      /* PASS THROUGH PARAMETERS */
      if (model.operationMode === OENOperationMode.MODIFY && model.passthroughParameters != null) {
        requestOrderData.passthroughParameters = model.passthroughParameters;
      }

      requestOrderData.isPrivateOrder = this.extractPrivateOrder(model);
      if (!model.isModificationPrivatized) {
        // !orderData.isPrivateOrder
        requestOrderData.clientCode = this.extractClient(model, errors);
        requestOrderData.accountCode = this.extractAccount(model, errors);
        requestOrderData.clientContactIds = this.extractContacts(model);
        requestOrderData.comment = this.extractComment1(model);
        requestOrderData.comment2 = this.extractComment2(model);

        request.clientTrader = this.extractClientTrader(model, errors);
      }

      model.bmarkRequestModel = request;

      // OBO CLIENT
      requestOrderData.oboClient = this.extractOBOClient(model, errors);

      // OBO Account
      requestOrderData.oboAccount = this.extractOBOAccount(model, errors);

      // CUSTOM FIELDS
      this.processCustomFields(model, requestOrderData, errors);

      //
      const allocationData = this.extractAllocationData(model, errors, asPartOfBulk);
      requestOrderData.allocations = allocationData.allocations;
      requestOrderData.farAllocations = allocationData.farAllocations;
      requestOrderData.swapFixedAmount = this.extractSwapFixedAmount(model, errors);
      requestOrderData.swapTenor = this.extractSwapTenor(model, errors);
      requestOrderData.swapValueDate = this.extractSwapValueDate(model, errors);

      /* MODEL ASSIGNMENT  */
      errors = errors.filter((e) => {
        return ignoreErrorSet.has(`${e.panel}_${e.input}`) == false;
      });

      if (errors.length === 0) {
        // no input data errors

        logger.out.info(
          `UI-MAIN: SUBMIT bmark -> RefID: ${model.refId} | OrderID: ${model.orderId}`,
        );
        return true;
      } else {
        // input data errors
        logger.out.info(
          `UI-MAIN: SUBMIT bmark -> RefID: ${model.refId} | OrderID: ${model.orderId} | errors: %O`,
          errors,
        );
        this.setter.reportValidationErrors(refId);
        return false;
      }
    } catch (ex) {
      logger.out.error(`EXCEPTION: oeForwardAdapter.prepareBmarkOrderRequestData(): %O`, ex);
      this.coordinator.cmdChangeDisplayState(
        refId,
        OENCommand.STATE_ORDER_INT_ERROR,
        "Internal error: exception = " + ex,
      );
      return false;
    }
  }

  /**********************************************************************/
  /**
   * This function takes the order data for the root node (with the entire strategy leg structure in it) and creates GammaOrderRequestImpl
   * @param rootRefId - this is the refId of the root node
   * @param rootOrderData -
   */
  protected prepareGammaOrderRequest(
    rootRefId: string,
    rootOrderData: CubiqTS.OrderRequestDataImpl,
    errors: Array<OEInputModel> = null,
  ): boolean {
    let result: boolean = false;

    if ((result = this.prepareLinkedOrderRequest(rootRefId, rootOrderData, errors))) {
      let rootModel: OEDataModel = this.getter.get(rootRefId);
      let gammaModel: OEPanelGammaViewModel = rootModel.gammaModel;
      let orderRequest: CubiqTS.GammaOrderRequestImpl =
        rootModel.requestModel as CubiqTS.GammaOrderRequestImpl;

      orderRequest.rungsAbove = gammaModel.gammaLegsAbove.length;
      orderRequest.rungsBelow = gammaModel.gammaLegsBelow.length;

      gammaModel.rungsAbove = orderRequest.rungsAbove;
      gammaModel.rungsBelow = orderRequest.rungsBelow;

      this.validateRungsAbove(gammaModel, errors);
      this.validateRungsBelow(gammaModel, errors);

      let clonedAboveLegs: Array<OEPanelGammaLeg> = [];
      let clonedBelowLegs: Array<OEPanelGammaLeg> = [];

      gammaModel.gammaLegsAbove.forEach((element) => {
        clonedAboveLegs.push(element.cloneGammaLeg());
      });
      clonedAboveLegs.sort((a, b) => a.rate.toNumber() - b.rate.toNumber());

      if (!rootModel.gammaModel.edit && !this.validator.validateDelta(rootModel)) {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.DELTA));
      }

      result = errors.length == 0;

      // Following code starting here will be replaced by generating the legs from the actual model
      let isInvertCcyPair: boolean =
        rootOrderData.base + rootOrderData.nonBase !=
        rootModel.ccyPairModel.base + rootModel.ccyPairModel.nonBase;
      let pipPrecision: number = isInvertCcyPair
        ? rootModel.ccyPairModel.spotInvertDecimalsQty
        : rootModel.ccyPairModel.rateDecimalsQty;

      let startIndex: number = orderRequest.rungsAbove;
      let rungId: number = 1;
      let parent: CubiqTS.OrderRequestDataImpl = null;
      let assignedReference: boolean = false;

      for (let i: number = startIndex; i >= -orderRequest.rungsBelow; --i) {
        if (i == 0) {
          orderRequest.extendedInfo.set(INFO_RUNGS_MID, rungId + "");
        }

        let orderData: CubiqTS.OrderRequestDataImpl = new CubiqTS.OrderRequestDataImpl();
        this.prepareOrderRequestData(rootRefId, orderData, errors);
        if (startIndex == i) {
          orderRequest.rootOrder = orderData;
        }

        if (!assignedReference && i != 0) {
          orderData.externalClientReference = orderData.externalClientReference;
          assignedReference = true;
        } else {
          orderData.externalClientReference = orderData.externalClientReference + "_" + rungId;
        }

        if (i == 0) {
          orderData.fixedAmount = "0.0";
          let gammaMidRate: CubiqTS.BigNumber = gammaModel.midRate[0].value;

          if (gammaMidRate instanceof CubiqTS.BigNumber && gammaMidRate.isGreaterThan(0)) {
            let gammaMidRateStr: string = gammaMidRate.toFixed(
              this.lookup.ccyPairPrecision(rootModel.ccyPair),
            );
            orderData.requestRate = gammaMidRateStr;
          }
        }

        rungId++;
        let leg: OEPanelGammaLeg;
        if (i < 0) {
          leg = gammaModel.gammaLegsBelow[(i + 1) * -1];
        } else if (i > 0) {
          leg = clonedAboveLegs[i - 1];
        }
        if (leg != null) {
          orderData.requestRate = leg.rate.toString();
          orderData.fixedAmount = leg.amount.toString();
        }

        if (orderData.orderType == CubiqTS.OrderType.LIMIT_TP) {
          orderData.clientIntent =
            i >= 0 === (orderData.fixedCcy == orderData.base)
              ? CubiqTS.OrderIntent.SELL
              : CubiqTS.OrderIntent.BUY;
        } else {
          orderData.clientIntent =
            i >= 0 === (orderData.fixedCcy == orderData.base)
              ? CubiqTS.OrderIntent.BUY
              : CubiqTS.OrderIntent.SELL;
        }

        if (parent != null) {
          let relationship: CubiqTS.LinkedRelationshipImpl = new CubiqTS.LinkedRelationshipImpl();
          relationship.parentId = parent.externalClientReference;
          relationship.relationshipType = CubiqTS.OrderRelationshipType.GAMMA;
          relationship.order = orderData;
          if (parent.childRelationships == null) {
            parent.childRelationships = [];
          }
          parent.childRelationships.push(relationship);
        }

        parent = orderData;
      }
      // Cut till here
    }

    return result;
  }

  /**********************************************************************/
  /* AMEND-MARKUP Request  */

  public createAmendMarkupRequest(
    refId: string,
    errorsMap: Map<string, Array<OEInputModel>>,
  ): CubiqTS.AmendMarkupSalesApprovalRequestImpl {
    if (this.getter.has(refId)) {
      let amendMarkupRequest = new CubiqTS.AmendMarkupSalesApprovalRequestImpl();
      amendMarkupRequest.diRequestItems = new Array<CubiqTS.DIRequestItemImpl>();
      ///
      let nodeIds: Array<string> = this.getter.getStrategyNodesListRoot(refId);
      nodeIds.forEach((itemRefId: string) => {
        // get the model
        let model = this.getter.get(itemRefId);
        if (model != null && model.orderId != null) {
          try {
            if (
              model.markup != null &&
              model.markup.checkbox != null &&
              model.markup.checkbox.enabled &&
              model.markup.checkbox.value &&
              (model.markup.value == null ||
                model.markup.typeValue == null ||
                model.markup.typeValue.value == null)
            ) {
              // error flow, added for OMS-32467
              let errors: Array<OEInputModel> = Array<OEInputModel>();
              if (model.markup.value == null) {
                errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.MARKUP));
              }
              if (model.markup.typeValue == null || model.markup.typeValue.value == null) {
                errors.push(
                  new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.MARKUP_TYPE),
                );
              }
              errorsMap.set(itemRefId, errors);
            } else {
              // error flow
              let requestItem = new CubiqTS.DIRequestItemImpl();
              requestItem.orderId = model.orderId;
              requestItem.markup =
                model.markup != null && model.markup.value != null
                  ? new CubiqTS.BigNumber(model.markup.value)
                  : null;
              requestItem.markupType =
                model.markup != null &&
                model.markup.typeValue != null &&
                model.markup.typeValue.value != null
                  ? model.markup.typeValue.value
                  : null;
              amendMarkupRequest.diRequestItems.push(requestItem);
            }
          } catch (ex) {
            logger.out.error(`EXCEPTION: _oeWorker.createAmendMarkupRequest(): %O`, ex);
          }
        }
      });
      return amendMarkupRequest;
    }
    return null;
  }

  /**********************************************************************/
  /* MODIFY INFO Request  [LinkedOrderInfoModificationRequestImpl]   */
  /**
   * LinkedOrderInfoModificationRequestImpl: changeMask bitfield values
   * Modify the client trader =>  public static long CM_CLIENT_TRADER=0x00000001;
   * Modify the client contacts setting  => public static long CM_CONTACTS=0x00000002;
   * Both => 3
   *
   * isContactsEnabled field is essentially useDefaultContacts  (mislabeled on sever side)
   * *********
   * OrderUpdate: changeMask bitfield values:
   * Modify comment 1 => public static long CM_COMMENT1=0x00000001;
   * Modify comment 2 => public static long CM_COMMENT2=0x00000002;
   * Both comments => 3
   * Modify the external order reference (clOrdId) => public static long CM_CL_ORD_ID=0x00000004;
   * All => 7
   */
  public createModifyInfoRequest(refId: string): boolean {
    try {
      if (this.getter.has(refId)) {
        // Order Entry Data Model - Interface
        let activeModel = this.getter.get(refId);
        let activeModelLockingProfile = this.getter.getLockingProfile(refId);
        //
        let requestModel: CubiqTS.LinkedOrderInfoModificationRequestImpl =
          new CubiqTS.LinkedOrderInfoModificationRequestImpl();
        requestModel.orderUpdates = new Array<CubiqTS.OrderUpdate>();
        // Set Ids
        requestModel.orderId = activeModel.orderId;
        requestModel.oboUser = activeModel.oboUser;

        ////////////////////////////////////////
        // ORDER UPDATE
        //orderUpdate.clOrdId = model.refId;
        let nodeIds: Array<string> = this.getter.getStrategyNodesListRoot(refId);
        nodeIds.forEach((itemRefId: string) => {
          // get the model
          let model = this.getter.get(itemRefId);
          // merged locking profile of both strategy and privatization
          let lockingProfile = this.getter.getLockingProfile(itemRefId);
          //
          let orderUpdate = new CubiqTS.OrderUpdateImpl();
          orderUpdate.orderId = model.orderId;
          //
          let orderUpdateChangeMaskNum = 0;
          // Client Comment
          let clientCommentLock =
            lockingProfile != null
              ? lockingProfile.getLockProfileForInputElement(OENInputControl.CLIENT_COMMENTS)
              : null;
          let clientCommentEnabled =
            clientCommentLock != null
              ? clientCommentLock.lockState !== OENLockedState.LOCKED
              : true;
          if (clientCommentEnabled && model.clientComment != null) {
            // && model.clientComment.value != null
            orderUpdate.comment1 = model.clientComment != null ? model.clientComment.value : null;
            orderUpdateChangeMaskNum = 1;
          }
          // Private Comment
          let privateCommentLock =
            lockingProfile != null
              ? lockingProfile.getLockProfileForInputElement(OENInputControl.PRIVATE_COMMENTS)
              : null;
          let privateCommentEnabled =
            privateCommentLock != null
              ? privateCommentLock.lockState !== OENLockedState.LOCKED &&
                this.settings.privateCommentsEnabled
              : this.settings.privateCommentsEnabled;
          if (privateCommentEnabled && model.privateComments) {
            orderUpdate.comment2 = model.privateComments;
            orderUpdateChangeMaskNum = orderUpdateChangeMaskNum === 1 ? 3 : 2;
          }
          // Order Update - Change Mask
          orderUpdate.changeMask =
            orderUpdateChangeMaskNum !== 0 ? new CubiqTS.Long(orderUpdateChangeMaskNum) : null;
          // attach order update to root
          requestModel.orderUpdates.push(orderUpdate);
        });
        ////////////////////////////////////////
        // ROOT LinkedOrderInfoModificationRequestImpl
        let rootChangeMaskNum = 0;
        // Client Trader
        let clientTraderLock =
          activeModelLockingProfile != null
            ? activeModelLockingProfile.getLockProfileForInputElement(OENInputControl.TRADER)
            : null;
        let clientTraderEnabled =
          clientTraderLock != null ? clientTraderLock.lockState !== OENLockedState.LOCKED : true;
        if (clientTraderEnabled) {
          requestModel.clientTrader = this.extractClientTrader(activeModel);

          // if(activeModel.clientTrader != null && activeModel.clientTrader instanceof ICAutocompleteGenericModel){
          // 	requestModel.clientTrader =  (<ICAutocompleteGenericModel>activeModel.clientTrader).label;
          // }else if(activeModel.clientTrader != null && activeModel.clientTrader instanceof CubiqTS.UserImpl) {
          // 	requestModel.clientTrader = (<CubiqTS.UserImpl>activeModel.clientTrader).userName; // not value
          // }else{
          // 	requestModel.clientTrader = null;
          // }
          rootChangeMaskNum = 1;
        }
        // Contacts
        let contactsLock =
          activeModelLockingProfile != null
            ? activeModelLockingProfile.getLockProfileForInputElement(OENInputControl.CONTACT)
            : null;
        let contactsEnabled =
          contactsLock != null ? contactsLock.lockState !== OENLockedState.LOCKED : true;
        if (contactsEnabled) {
          requestModel.clientContactIds = new Array<CubiqTS.Long>();
          if (activeModel.contacts != null && activeModel.contacts.length > 0) {
            activeModel.contacts.forEach((contact: CubiqTS.ClientContactImpl) => {
              requestModel.clientContactIds.push(contact.id);
            });
          }
          rootChangeMaskNum = rootChangeMaskNum === 1 ? 3 : 2;
        }
        // Order Update - Change Mask
        requestModel.changeMask =
          rootChangeMaskNum !== 0 ? new CubiqTS.Long(rootChangeMaskNum) : null;
        // useDefaultContacts => Based on discussion with Darren (23.11.2018) for MODIFY_INFO should always be null or false;
        requestModel.isContactsEnabled = false;
        ////////////////////////////////////////
        // Attach LinkedOrderInfoModificationRequestImpl to Model
        this.setter.setModifyInfoRequestModel(refId, requestModel);
        return true;
      }
    } catch (ex) {
      logger.out.error(
        `EXCEPTION: _oeWorker.createModifyInfoRequest(): refId: '${refId}' error: %O`,
        ex,
      );
    }
    return false;
  }

  /**********************************************************************/
  /* HELPERS - GENERAL  */

  private defineRequestModel(
    rootModel: OEDataModel,
  ): CubiqTS.LinkedOrderModificationRequestImpl | CubiqTS.LinkedOrderRequestImpl {
    if (rootModel instanceof OEDataModel) {
      if (
        rootModel.strategy &&
        rootModel.strategy.strategyType &&
        rootModel.strategy.strategyType === CubiqTS.StrategyType.GAMMA
      ) {
        return new CubiqTS.GammaOrderRequestImpl();
      } else if (
        rootModel.operationMode === OENOperationMode.MODIFY ||
        rootModel.operationMode === OENOperationMode.MODIFY_INFO ||
        rootModel.operationMode === OENOperationMode.MODIFY_SCRATCHPAD
      ) {
        let requestModel = new CubiqTS.LinkedOrderModificationRequestImpl();
        if (rootModel.isModificationPrivatized) {
          requestModel.privatisedRequest = true;
        }
        return requestModel;
      } else if (
        rootModel.operationMode === OENOperationMode.NEW ||
        rootModel.operationMode === OENOperationMode.DUPLICATE ||
        rootModel.operationMode === OENOperationMode.EDIT
      ) {
        return new CubiqTS.LinkedOrderRequestImpl();
      }
    }
    logger.out.error(
      "ERROR: _oeWorker.prepareLinkedOrderRequest(): Submit failed, invalid operation mode!",
    );
    return null;
  }

  private deleteErrorsForElement(
    input: OENInputControl,
    errors: Array<OEInputModel>,
  ): Array<OEInputModel> {
    let filteredErrors = new Array<OEInputModel>();
    if (input != null && errors != null && errors.length > 0) {
      filteredErrors = errors.filter((item) => item.input !== input);
    }
    return filteredErrors;
  }

  private isBMarkOrder(model: OEDataModel): boolean {
    return (
      model instanceof OEDataModel &&
      model.orderType instanceof ICAutocompleteGenericModel &&
      model.orderType.value === CubiqTS.RequestOrderType.BMARK
    );
  }

  private isMarketOrder(model: OEDataModel): boolean {
    return (
      model instanceof OEDataModel &&
      model.orderType instanceof ICAutocompleteGenericModel &&
      model.orderType.value === CubiqTS.RequestOrderType.MARKET
    );
  }

  private isAlgoOrder(model: OEDataModel): boolean {
    return (
      (model instanceof OEDataModel &&
        model.orderType instanceof ICAutocompleteGenericModel &&
        model.orderType.value === CubiqTS.RequestOrderType.ALGO) ||
      model.algoType != null
    );
  }

  private isCallOrder(model: OEDataModel): boolean {
    return (
      model instanceof OEDataModel &&
      model.orderType instanceof ICAutocompleteGenericModel &&
      model.orderType.value === CubiqTS.RequestOrderType.CALL
    );
  }

  private isTSLOrder(model: OEDataModel): boolean {
    return (
      model instanceof OEDataModel &&
      model.orderType instanceof ICAutocompleteGenericModel &&
      (model.orderType.value === CubiqTS.RequestOrderType.TSL ||
        model.orderType.value === CubiqTS.RequestOrderType.TSL_ASK ||
        model.orderType.value === CubiqTS.RequestOrderType.TSL_BID)
    );
  }

  private isFwdOutright(model: OEDataModel): boolean {
    let product = this.extractProduct(model);

    return (
      model instanceof OEDataModel &&
      (product === CubiqTS.Product.FWD || product === CubiqTS.Product.NDF) &&
      model.trigger?.value === CubiqTS.RequestTrackingType.OUTRIGHT_RATE
    );
  }

  private isGammaEdit(model: OEDataModel): boolean {
    return model != null && model.gammaModel != null && model.gammaModel.edit === true;
  }

  private cleanupRequestOrderData(requestOrderData: any): void {
    if (requestOrderData instanceof Object) {
      for (const property in requestOrderData) {
        if (requestOrderData[property] === undefined) {
          delete requestOrderData[property];
        }
      }
    }
  }

  private isCcyPairFwdEnabled(model: OEDataModel): boolean {
    return (
      model.ccyPairModel instanceof CubiqTS.CurrencyPairImpl &&
      !(model.ccyPairModel.allowFwdFwdTriggerFg || model.ccyPairModel.allowFwdSpotTriggerFg)
    );
  }
  /**********************************************************************/
  /* HELPERS - EXTRACT ORDER PARAMETER VALUES  */

  protected extractExternalReference(model: OEDataModel): string {
    return model.refId;
  }

  // CLIENT
  protected extractClient(model: OEDataModel, errors: Array<OEInputModel>): string {
    let value = undefined;
    if (!model.isModificationPrivatized) {
      if (model.client instanceof CubiqTS.ClientImpl && model.client.ordersEnabledFg) {
        // validate the client in regards to the entry type
        if (
          model.entryType === OENEntryType.SPOT ||
          model.entryType === OENEntryType.NDF ||
          model.entryType === OENEntryType.GAMMA
        ) {
          value = model.client.clientId;
        } else if (
          (model.entryType === OENEntryType.ALGO || model.entryType === OENEntryType.NDF_ALGO) &&
          model.client.autoFillEnabled
        ) {
          value = model.client.clientId;
        } else if (
          model.entryType === OENEntryType.BENCHMARK &&
          this.oeLookup.isBranchBenchmarkEnabled(model.client.branchCd)
        ) {
          value = model.client.clientId;
        } else {
          errors.push(new OEInputModel(OENPanel.PANEL_CLIENT, OENInputControl.CLIENT));
        }
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_CLIENT, OENInputControl.CLIENT));
      }
    }
    return value;
  }

  // ACCOUNT
  protected extractAccount(model: OEDataModel, errors: Array<OEInputModel>): string {
    let value: string = undefined;
    if (!model.isModificationPrivatized) {
      if (model.account instanceof CubiqTS.AccountImpl) {
        // basic validation
        let clientId = this.extractClient(model, []);
        if (typeof clientId === "string") {
          // ensure client is correct, otherwise no point in checking client/account association
          if (
            model.account.salesGroupId == null &&
            Array.isArray(model.account.associatedClients) &&
            model.account.associatedClients.length > 0 &&
            model.account.associatedClients.findIndex((item) => item === clientId) > -1
          ) {
            // check if account is associated with client
            value = model.account.id;
          } else if (
            model.account.salesGroupId instanceof CubiqTS.Long &&
            model.client.salesGroupId instanceof CubiqTS.Long &&
            model.account.salesGroupId.equals(model.client.salesGroupId)
          ) {
            // check if break account is available for client
            value = model.account.id;
          } else {
            errors.push(new OEInputModel(OENPanel.PANEL_CLIENT, OENInputControl.ACCOUNT));
          }
        }
      } else if (!model.bulking) {
        errors.push(new OEInputModel(OENPanel.PANEL_CLIENT, OENInputControl.ACCOUNT));
      }
    }
    return value;
  }

  // ALLOCATIONS
  protected extractAllocationData(
    model: OEDataModel,
    errors: Array<OEInputModel>,
    asPartOfBulk: boolean = false,
  ): { allocations: any[]; farAllocations: any[] } {
    let value = {
      allocations: null,
      farAllocations: null,
    };

    if (!asPartOfBulk && model.bulked === false && model.bulking === true) {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.ALLOCATIONS));
    }

    if (Array.isArray(model.allocations)) {
      value.allocations = model.allocations;
    }

    if (Array.isArray(model.farAllocations)) {
      value.farAllocations = model.farAllocations;
    }

    return value;
  }

  protected extractSwapFixedAmount(model: OEDataModel, _: Array<OEInputModel>): any {
    let value: any = null;

    if (model.swapFixedAmount != null) {
      return model.swapFixedAmount;
    }

    return value;
  }

  protected extractSwapTenor(model: OEDataModel, _: Array<OEInputModel>): any {
    let value: any = null;

    if (model.swapTenor != null) {
      return model.swapTenor;
    }

    return value;
  }

  protected extractSwapValueDate(model: OEDataModel, _: Array<OEInputModel>): any {
    let value: any = null;

    if (model.swapValueDate != null) {
      return model.swapValueDate;
    }

    return value;
  }

  // CCY PAIR - FULL
  protected extractCcyPairFull(model: OEDataModel, errors: Array<OEInputModel>): string {
    let value: string = undefined;
    if (
      typeof model.ccyPair === "string" &&
      model.ccyPair.length === 6 &&
      model.ccyPairModel instanceof CubiqTS.CurrencyPairImpl
    ) {
      value = model.ccyPair;
    } else {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.CCY_PAIR));
    }
    return value;
  }

  // CCY PAIR - BASE
  protected extractCcyPairBase(model: OEDataModel, errors: Array<OEInputModel>): string {
    let value: string = undefined;
    if (
      typeof model.ccyPair === "string" &&
      model.ccyPair.length === 6 &&
      model.ccyPairModel instanceof CubiqTS.CurrencyPairImpl
    ) {
      let rootModel = this.getter.getRootModel(model.refId);
      if (
        this.getter.isRootNode(model.refId) || // is root
        (rootModel instanceof OEDataModel && model.ccyPair === rootModel.ccyPair) || // OR ccy par is same as root
        (model.orderType instanceof ICAutocompleteGenericModel &&
          model.orderType.value === CubiqTS.RequestOrderType.MARKET)
      ) {
        // OR is MKT order
        value = model.ccyPair.substr(0, 3);
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.CCY_PAIR));
      }
    } else {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.CCY_PAIR));
    }
    return value;
  }

  // CCY PAIR - NON-BASE
  protected extractCcyPairNonBase(model: OEDataModel, errors: Array<OEInputModel>): string {
    let value: string = undefined;
    if (
      typeof model.ccyPair === "string" &&
      model.ccyPair.length === 6 &&
      model.ccyPairModel instanceof CubiqTS.CurrencyPairImpl
    ) {
      let rootModel = this.getter.getRootModel(model.refId);
      if (
        this.getter.isRootNode(model.refId) || // is root
        (rootModel instanceof OEDataModel && model.ccyPair === rootModel.ccyPair) || // OR ccy par is same as root
        (model.orderType instanceof ICAutocompleteGenericModel &&
          model.orderType.value === CubiqTS.RequestOrderType.MARKET)
      ) {
        // OR is MKT order
        value = model.ccyPair.substr(3, 3);
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.CCY_PAIR));
      }
    } else {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.CCY_PAIR));
    }
    return value;
  }

  // ORDER TYPE - REQUEST
  protected extractRequestOrderType(
    model: OEDataModel,
    errors: Array<OEInputModel>,
  ): CubiqTS.RequestOrderType {
    let value: CubiqTS.RequestOrderType = undefined;
    if (
      model.orderType instanceof ICAutocompleteGenericModel &&
      CubiqTS.RequestOrderType.getAllElements().includes(model.orderType.value)
    ) {
      if (model.orderType.value === CubiqTS.RequestOrderType.MARKET) {
        if (this.isValidMarketOrderType(model)) {
          value = model.orderType.value;
        } else {
          errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.ORDER_TYPE));
        }
      } else {
        value = model.orderType.value;
      }
    } else {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.ORDER_TYPE));
    }
    return value;
  }

  // ORDER TYPE
  protected extractOrderType(model: OEDataModel, errors: Array<OEInputModel>): CubiqTS.OrderType {
    let value: CubiqTS.OrderType = undefined;
    if (
      model.orderType instanceof ICAutocompleteGenericModel &&
      CubiqTS.RequestOrderType.getAllElements().includes(model.orderType.value)
    ) {
      if (model.orderType.value === CubiqTS.RequestOrderType.MARKET) {
        if (this.isValidMarketOrderType(model)) {
          value = this.utility.convertRequestOrderTypeToOrderType(model.orderType.value);
        } else {
          errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.ORDER_TYPE));
        }
      } else {
        value = this.utility.convertRequestOrderTypeToOrderType(model.orderType.value);
      }
    } else {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.ORDER_TYPE));
    }
    return value;
  }

  // CLIENT INTENT
  protected extractClientIntent(
    model: OEDataModel,
    errors: Array<OEInputModel>,
  ): CubiqTS.OrderIntent {
    let value: CubiqTS.OrderIntent = undefined;
    if (!this.isCallOrder(model)) {
      if (model.clientIntent != null) {
        value = model.clientIntent;
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.CLIENT_INTENT));
      }
    }
    return value;
  }

  // FIXED CCY
  protected extractFixedCCY(model: OEDataModel, errors: Array<OEInputModel>): string {
    let ret: string = undefined;
    if (!this.isCallOrder(model)) {
      if (typeof model.ccyPair === "string") {
        // if not string ccyPars has error, no point in checking fixed ccy
        if (
          model.fixedCcy != null &&
          typeof model.fixedCcy.ccy === "string" &&
          model.fixedCcy.ccy.length === 3 &&
          (model.fixedCcy.ccy == model.ccyPair.substr(0, 3) ||
            model.fixedCcy.ccy == model.ccyPair.substr(3, 3))
        ) {
          ret = model.fixedCcy.ccy;
        } else {
          errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.FIXED_CCY));
        }
      }
    }
    return ret;
  }

  // AMOUNT
  protected extractFixedAmount(model: OEDataModel, errors: Array<OEInputModel>): string {
    let value: string = undefined;
    if (!this.isCallOrder(model) && !this.isGammaEdit(model)) {
      if (model.orderAmount instanceof CubiqTS.BigNumber) {
        value = model.orderAmount.toString();
      }

      if ((!model.orderAmount || model.orderAmount.isZero()) && !this.isBMarkOrder(model)) {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.ORDER_AMOUNT));
      } else if (this.isBMarkOrder(model) && model.bmZeroAmountAccept) {
        // If we have accepted an empty amount for BMs, then we explicitly set amount to 0
        value = "0";
      }
    }
    return value;
  }

  // REQUEST PRICE
  protected extractRequestRate(model: OEDataModel, errors: Array<OEInputModel>): string {
    let value: string = undefined;
    if (!this.isMarketOrder(model) && !this.isAlgoOrder(model)) {
      // not required in algos and mkt orders
      if (model.requestPrice instanceof CubiqTS.BigNumber && model.requestPrice.isGreaterThan(0)) {
        let precision = this.lookup.ccyPairPrecision(model.ccyPair);

        if (this.isFwdOutright(model)) {
          precision = this.lookup.ccyPairFwdPrecision(model.ccyPair);
        }

        value = model.requestPrice.toFixed(precision);
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.REQUEST_PRICE));
      }
    } else if (this.isMarketOrder(model) && !(model.requestPrice == null)) {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.REQUEST_PRICE));
    }
    return value;
  }

  // REQUEST PRICE
  protected extractTrailingPips(model: OEDataModel, errors: Array<OEInputModel>): string {
    let value: string = null;
    if (this.isTSLOrder(model)) {
      if (
        model.trailingPips instanceof CubiqTS.BigNumber &&
        model.trailingPips.isGreaterThanOrEqualTo(this.lookup.ccyPairMinTSL(model.ccyPair))
      ) {
        value = model.trailingPips.toFixed(this.lookup.ccyPairPrecision(model.ccyPair));
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.TRAILING_PIPS));
      }
    }
    return value;
  }

  // REQUEST PRICE
  protected extractTrailingTrigger(model: OEDataModel, _: Array<OEInputModel>): string {
    let value: string = null;
    if (this.isTSLOrder(model) && model.trailingTriggerProvided) {
      if (
        model.trailingTrigger instanceof CubiqTS.BigNumber &&
        model.trailingTrigger.isGreaterThan(0)
      ) {
        value = model.trailingTrigger.toFixed(this.lookup.ccyPairPrecision(model.ccyPair));
      }
    }
    return value;
  }

  // VALUE DATE
  protected extractValueDate(
    model: OEDataModel,
    errors: Array<OEInputModel>,
  ): CubiqTS.Tenor | CubiqTS.StandardDateImpl {
    let value: any = undefined;
    if (
      model.valueDate instanceof ICTenorValueDateModel &&
      model.valueDate.value != null &&
      !this.isDateOfValueDateInvalid(model.valueDate)
    ) {
      if (model.valueDate.tenor != null) {
        if (CubiqTS.Tenor.getAllElements().includes(model.valueDate.tenor)) {
          value = model.valueDate.tenor;
        } else {
          errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.VALUE_DATE));
        }
      } else if (model.valueDate.valueDate != null) {
        value = new CubiqTS.StandardDateImpl();
        value.year = model.valueDate.valueDate.getFullYear();
        value.month = model.valueDate.valueDate.getMonth() + 1;
        value.day = model.valueDate.valueDate.getDate();
      }
    } else {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.VALUE_DATE));
    }

    return value;
  }

  // CLIENT COMMENT
  protected extractComment1(model: OEDataModel): string {
    let value: string = undefined;
    if (model.isModificationPrivatized && model.isModificationClientCommentsPrivatized) {
      value = null;
    } else if (model.clientComment != null && model.clientComment.value != null) {
      value = model.clientComment.value;
    } else {
      value = "";
    }
    return value;
  }

  // PRIVATE COMMENT
  protected extractComment2(model: OEDataModel): string {
    let value: string = undefined;
    if (model.isModificationPrivatized && model.isModificationPrivateCommentsPrivatized) {
      value = null;
    } else if (model.privateComments != null) {
      value = model.privateComments;
    } else {
      value = "";
    }
    return value;
  }

  // TRADER GROUP
  protected extractTraderGroup(model: OEDataModel, errors: Array<OEInputModel>): string {
    let value: string = undefined;
    if (model.traderGroup != null) {
      if (model.traderGroup instanceof CubiqTS.TradingGroupImpl) {
        if (this.isMarketOrder(model)) {
          if (!model.traderGroup.isAutoFilledFg) {
            value = model.traderGroup.groupCode;
          } else {
            errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.TRADER_GROUP));
          }
        } else {
          value = model.traderGroup.groupCode;
        }
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.TRADER_GROUP));
      }
    }
    return value;
  }

  // HOLD STP (Checkbox)
  protected extractHoldSTP(model: OEDataModel): boolean {
    return model.holdSTP;
  }
  // AUTO FORWARD PRICING (Checkbox)
  protected extractAutoFwdPrice(model: OEDataModel): boolean {
    let simpleSpot =
      (model.valueDate == null || model.valueDate.tenor == CubiqTS.Tenor.SPOT) &&
      (null == model.product || model.product == CubiqTS.Product.SPT);

    if (simpleSpot) {
      return null;
    }
    return model.autoForwardPrice;
  }

  // PRIVATE ORDER (Checkbox)
  protected extractPrivateOrder(model: OEDataModel): boolean {
    return model.privateOrder;
  }

  // EXECUTION MODE (Checkbox)
  protected extractExecutionMode(model: OEDataModel): CubiqTS.RequestorFillTypeRestriction {
    let value: CubiqTS.RequestorFillTypeRestriction = undefined;
    if (model.entryType === OENEntryType.ALGO) {
      value = CubiqTS.RequestorFillTypeRestriction.AUTO;
    } else if (
      (model.entryType === OENEntryType.SPOT || model.entryType === OENEntryType.NDF) &&
      this.isMarketOrder(model)
    ) {
      value = CubiqTS.RequestorFillTypeRestriction.MANUAL;
    } else if (model.executionMode != null) {
      if (model.executionMode === CubiqTS.ExecutionType.AUTOMATIC) {
        value = CubiqTS.RequestorFillTypeRestriction.AUTO;
      } else {
        value = CubiqTS.RequestorFillTypeRestriction.MANUAL;
      }
    }
    return value;
  }

  // PARTIAL FILL (Checkbox)
  protected extractAllowPartialFills(model: OEDataModel): CubiqTS.FillSupport {
    let value: CubiqTS.FillSupport = ConstraintValue.isEnabled(model.allowPartialFills)
      ? CubiqTS.FillSupport.ALLOW_PARTIAL
      : CubiqTS.FillSupport.ALL_OR_NOTHING;

    return value;
  }

  // CONTACTS
  protected extractContacts(model: OEDataModel): Array<CubiqTS.Long> {
    let value: Array<CubiqTS.Long> = undefined;
    if (model.isModificationPrivatized) {
      value = undefined;
    } else if (model.contacts && model.contacts.length > 0) {
      value = (model.contacts as Array<CubiqTS.ClientContactImpl>).map(
        (value: CubiqTS.ClientContactImpl) => value.id,
      );
    }
    return value;
  }

  // CLIENT TRADER
  protected extractClientTrader(model: OEDataModel, errors: Array<OEInputModel> = []): string {
    let value: string = undefined;
    if (null != model.clientTrader) {
      if (!model.isModificationPrivatized) {
        if (model.clientTrader instanceof ICAutocompleteGenericModel) {
          value = model.clientTrader.value.userName;
        } else if (model.clientTrader instanceof CubiqTS.UserImpl) {
          value = model.clientTrader.userName;
        } else {
          value = model.clientTrader;
          errors.push(new OEInputModel(OENPanel.PANEL_CLIENT, OENInputControl.TRADER));
        }
      }
    }
    return value;
  }

  // MARKUP
  protected extractMarkup(model: OEDataModel) {
    let ret: string = null;
    // Throw error if checkbox is selected and has no values
    if (
      model.markup !== null &&
      model.markup instanceof ICMarkupModel &&
      model.markup.checkbox.value &&
      model.markup.textValue &&
      model.markup.textValue.length > 0
    ) {
      ret = model.markup.textValue;
    }
    return ret;
  }

  // MARKUP TYPE
  protected extractMarkupType(model: OEDataModel) {
    let ret: any = null;
    // Throw error if checkbox is selected and has no values
    if (
      model.markup !== null &&
      model.markup instanceof ICMarkupModel &&
      model.markup.checkbox.value &&
      model.markup.typeValue
    ) {
      ret = model.markup.typeValue.value;
    }
    return ret;
  }

  // FIXING SOURCE (NDF Only)
  protected extractFixingSource(model: OEDataModel, errors: Array<OEInputModel>): string {
    let value: string = undefined;
    if (model.entryType === OENEntryType.NDF) {
      if (
        model.fixingSource instanceof ICFixingSourceModel &&
        typeof model.fixingSource.value === "string"
      ) {
        if (model.fixingSource.id != -1) {
          value = model.fixingSource.value;
        } else if (model.clientComment == null || model.clientComment.value == "") {
          errors.push(new OEInputModel(OENPanel.PANEL_MORE, OENInputControl.CLIENT_COMMENTS));
        }
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.FIXING_SOURCE));
      }
    }
    return value;
  }

  protected extractTrigger(
    model: OEDataModel,
    errors: Array<OEInputModel>,
  ): CubiqTS.RequestTrackingType {
    let value: CubiqTS.RequestTrackingType = undefined;
    if (
      model.entryType === OENEntryType.NDF ||
      (model.valueDate instanceof ICTenorValueDateModel &&
        model.valueDate.tenor !== CubiqTS.Tenor.SPOT)
    ) {
      if (
        model.trigger instanceof ICAutocompleteGenericModel &&
        CubiqTS.RequestTrackingType.getAllElements().includes(model.trigger.value)
      ) {
        value = model.trigger.value;
      } else if (
        model.entryType === OENEntryType.ALGO ||
        model.entryType === OENEntryType.NDF_ALGO
      ) {
        // we have algo forward at this point, tenor is non spot
        value = CubiqTS.RequestTrackingType.SPOT_RATE;
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.TRIGGER));
      }
    }

    return value;
  }
  protected extractProduct(model: OEDataModel): CubiqTS.Product {
    let value: CubiqTS.Product = undefined;
    if (model.product != null) {
      value = model.product;
    } else if (model.entryType === OENEntryType.NDF || model.entryType === OENEntryType.NDF_ALGO) {
      value = CubiqTS.Product.NDF;
    } else if (
      model.valueDate instanceof ICTenorValueDateModel &&
      model.valueDate.tenor !== CubiqTS.Tenor.SPOT
    ) {
      value = CubiqTS.Product.FWD;
    } else {
      value = CubiqTS.Product.SPT;
    }
    return value;
  }

  /* FIXING CONTROLS */
  protected extractFixingCode(model: OEDataModel, errors: OEInputModel[]): string {
    let ret: string = null;
    if (model.fixingCode != null && model.fixingCode != "") {
      ret = model.fixingCode;
    } else {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.FIXING_SOURCE));
    }
    return ret;
  }

  protected extractFixingDate(model: OEDataModel, errors: OEInputModel[]): CubiqTS.StandardDate {
    let ret: CubiqTS.StandardDate = new CubiqTS.StandardDateImpl();

    if (model.fixingDate != null) {
      ret.year = model.fixingDate.getFullYear();
      ret.month = model.fixingDate.getMonth() + 1; // zero based???
      ret.day = model.fixingDate.getDate();

      if (model.orderId != null && this.timeMachine.isFixingDatePast(model.fixingDate)) {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.FIXING_DATE));
      }
    } else {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.FIXING_DATE));
    }

    return ret;
  }

  protected extractFixingTime(model: OEDataModel, errors: OEInputModel[]): CubiqTS.StandardTime {
    let ret: CubiqTS.StandardTimeImpl = new CubiqTS.StandardTimeImpl();

    if (model.fixingTime != null) {
      ret.hours = Number(model.fixingTime.substr(0, 2)).valueOf();
      ret.minutes = Number(model.fixingTime.substr(2, 4)).valueOf();
      ret.seconds = 0;

      if (
        model.orderId != null &&
        this.timeMachine.isFixingTimePast(
          { value: model.fixingDate },
          model.fixingTime + " " + model.fixingTimezone,
        )
      ) {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.FIXING_DATE));
      }
    } else {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.FIXING_TIME));
    }

    ret.timeZone = "GMT";
    if (model.fixingTimezone != null) {
      ret.timeZone = model.fixingTimezone;
    }

    return ret;
  }

  protected extractOBOClient(model: OEDataModel, errors: OEInputModel[]): string {
    return model.oboClient;
  }

  protected extractOBOAccount(model: OEDataModel, errors: OEInputModel[]): string {
    return model.oboAccount;
  }

  protected extractOrderRef(model: OEDataModel, errors: OEInputModel[]): string {
    return model.orderRef;
  }

  protected extractDelta(model: OEDataModel, errors: OEInputModel[]): string {
    let delta: string = model.delta;

    if (!this.validator.validateDelta(model)) {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.DELTA));
    }

    return delta;
  }

  protected validateRungsAbove(model: any, errors: OEInputModel[]): number {
    let rungsAbove: number = model.rungsAbove;

    if (!this.validator.validateRungsAbove(model)) {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.RUNGS_ABOVE));
    }

    return rungsAbove;
  }

  protected validateRungsBelow(model: any, errors: OEInputModel[]): number {
    let rungsBelow: number = model.rungsBelow;

    if (!this.validator.validateRungsBelow(model)) {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.RUNGS_BELOW));
    }

    return rungsBelow;
  }

  /**********************************************************************/
  /* HELPERS - Complex request model extraction and assignment  */

  // VALUE DATE
  private assignValueDate(
    valueDate: CubiqTS.StandardDateImpl | CubiqTS.Tenor,
    requestOrderData: any,
  ): void {
    if (requestOrderData != null) {
      if (valueDate instanceof CubiqTS.StandardDateImpl) {
        requestOrderData.valueDate = valueDate;
      } else if (valueDate != null) {
        requestOrderData.tenor = valueDate;
      }
    }
  }

  // MARKUP
  protected extractAndAssignMarkup(
    model: OEDataModel,
    requestOrderData: any,
    errors: Array<OEInputModel>,
  ): void {
    if (model.originalMarkup.submitOriginalMarkup) {
      // workaround (see notes in oe-data.model.ts)
      requestOrderData.markup =
        model.originalMarkup.value instanceof CubiqTS.BigNumber
          ? model.originalMarkup.value.toString()
          : model.originalMarkup.value;
      requestOrderData.markupType = model.originalMarkup.type;
    } else if (
      model.originalMarkup.conversionToPipsApplied &&
      (model.operationMode === OENOperationMode.MODIFY_SCRATCHPAD ||
        model.operationMode === OENOperationMode.MODIFY)
    ) {
      // added to fix OMS-31130
      if (
        model.markup !== null &&
        model.markup instanceof ICMarkupModel &&
        model.markup.checkbox != null &&
        model.markup.checkbox.enabled
      ) {
        if (!model.markup.checkbox.value || model.markup.value == null) {
          this.oeLogger.outputDevLogToConsole(
            `MARKUP: NULL CONVERSION -> original: ${model.originalMarkup.value.toString()} [${
              CubiqTS.MarkUpType[model.originalMarkup.type]
            }] | model: ${model.markup.value.toString()} [${
              CubiqTS.MarkUpType[model.markup.typeValue.value]
            }] `,
          );
          requestOrderData.markup = null;
        } else if (model.markup.value.isEqualTo(0)) {
          this.oeLogger.outputDevLogToConsole(
            `MARKUP: ZERO CONVERSION -> original: ${model.originalMarkup.value.toString()} [${
              CubiqTS.MarkUpType[model.originalMarkup.type]
            }] | model: ${model.markup.value.toString()} [${
              CubiqTS.MarkUpType[model.markup.typeValue.value]
            }] `,
          );
          requestOrderData.markup = "0";
        } else {
          let isInvertCcyPair: boolean =
            requestOrderData.base + requestOrderData.nonBase ===
            model.ccyPairModel.base + model.ccyPairModel.nonBase;
          let multiplier = this.utility.getForwardDecsToPipsMultiplier(
            model.ccyPairModel,
            isInvertCcyPair,
          );
          let precision = this.utility.getPipsPrecisionForCcyPair(
            model.ccyPairModel,
            isInvertCcyPair,
          );

          let convertedValue = new CubiqTS.BigNumber(
            model.markup.value.dividedBy(multiplier).toFixed(precision),
          );
          this.oeLogger.outputDevLogToConsole(
            `MARKUP: REVERSE CONVERSION -> original: ${model.originalMarkup.value.toString()} [${
              CubiqTS.MarkUpType[model.originalMarkup.type]
            }] | model: ${model.markup.value.toString()} [${
              CubiqTS.MarkUpType[model.markup.typeValue.value]
            }] | multi: ${multiplier} | precision: ${precision} | converted ${convertedValue.toString()}`,
          );
          requestOrderData.markup = convertedValue.toString();
        }
      } else {
        requestOrderData.markup = model.originalMarkup.value.toString();
      }
      requestOrderData.markupType = model.originalMarkup.type;
    } else {
      if (this.isValidMarkup(model)) {
        if (model.markup != null && model.markup.value != null && model.markup.typeValue != null) {
          this.oeLogger.outputDevLogToConsole(
            `MARKUP: NORMAL -> model: ${model.markup.value.toString()} [${
              CubiqTS.MarkUpType[model.markup.typeValue.value]
            }] `,
          );
        } else {
          this.oeLogger.outputDevLogToConsole(`MARKUP: NORMAL -> model: value and/or type is null`);
        }
        requestOrderData.markup = this.extractMarkup(model);
        requestOrderData.markupType = this.extractMarkupType(model);
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.MARKUP));
      }
    }
  }

  // SUSPEND
  protected extractAndAssignSuspend(
    model: OEDataModel,
    requestOrderData: any,
    errors: Array<OEInputModel>,
  ): void {
    if (model.suspend != null && model.suspend.activated === true) {
      if (this.getter.doesStrategyHaveMKTLeg(model.refId)) {
        // suspend not allowed on market orders
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.SUSPEND));
      } else if (
        model.suspend.suspendFrom != null &&
        model.suspend.suspendFrom.timeValue != null &&
        model.suspend.suspendFrom.timezoneValue != null &&
        NOSECS_VALIDATE_TIME_PATTERN.test(model.suspend.suspendFrom.timeValue) &&
        model.suspend.suspendTo != null &&
        model.suspend.suspendTo.timeValue != null &&
        model.suspend.suspendTo.timezoneValue != null &&
        NOSECS_VALIDATE_TIME_PATTERN.test(model.suspend.suspendTo.timeValue) &&
        (model.suspend.suspendFrom.timeValue !== model.suspend.suspendTo.timeValue ||
          model.suspend.suspendFrom.timezoneValue.value !==
            model.suspend.suspendTo.timezoneValue.value)
      ) {
        if (requestOrderData.strategyParameters == null) {
          requestOrderData.strategyParameters = [];
        }

        let startTime: CubiqTS.StrategyParameter = new CubiqTS.StrategyParameterImpl();
        startTime.parameterName = VALID_FROM_TIME;
        startTime.parameterValue = String(model.suspend.suspendFrom.timeValue);
        startTime.parameterType = SUSPENSION_PARAM_TYPE;

        let endTime: CubiqTS.StrategyParameter = new CubiqTS.StrategyParameterImpl();
        endTime.parameterName = VALID_TO_TIME;
        endTime.parameterValue = String(model.suspend.suspendTo.timeValue);
        endTime.parameterType = SUSPENSION_PARAM_TYPE;

        let startTz: CubiqTS.StrategyParameter = new CubiqTS.StrategyParameterImpl();
        startTz.parameterName = VALID_FROM_TIMEZONE;
        startTz.parameterValue = String(model.suspend.suspendFrom.timezoneValue.value);
        startTz.parameterType = SUSPENSION_PARAM_TYPE;

        let endTz: CubiqTS.StrategyParameter = new CubiqTS.StrategyParameterImpl();
        endTz.parameterName = VALID_TO_TIMEZONE;
        endTz.parameterValue = String(model.suspend.suspendTo.timezoneValue.value);
        endTz.parameterType = SUSPENSION_PARAM_TYPE;

        requestOrderData.strategyParameters.push(startTime);
        requestOrderData.strategyParameters.push(endTime);
        requestOrderData.strategyParameters.push(startTz);
        requestOrderData.strategyParameters.push(endTz);
      } else {
        errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.SUSPEND));
      }
    }
  }

  // GOOD FROM & UNTIL
  private extractAndAssignGoodFromUntil(
    model: OEDataModel,
    requestOrderData: any,
    errors: Array<OEInputModel>,
  ): void {
    /* ACTIVATION - EXPIRY VALIDATION - START */
    // Populate good from until
    let goodFromFormatValid = true;
    let goodFromSetButNotNOW =
      model.goodFrom != null &&
      model.goodFrom.marketValue != null &&
      model.goodFrom.marketValue != "NOW";
    let goodFromIsNull = this.timeMachine.checkIfGoodFromUntilModelIsEmpty(model.goodFrom);
    if (goodFromSetButNotNOW) {
      if (!goodFromIsNull && this.validator.validateActivation(model.goodFrom)) {
        if (requestOrderData.activationDetails == null) {
          requestOrderData.activationDetails = new CubiqTS.ActivationDetailsImpl();
        }

        let timeValue = "";
        if (
          model.goodFrom.timeValue != null &&
          model.goodFrom.timeValue instanceof ICTimeControlModel
        ) {
          timeValue = model.goodFrom.timeValue.timeValue;
        } else if (typeof model.goodFrom.timeValue === "string") {
          timeValue = model.goodFrom.timeValue;
        }

        requestOrderData.activationDetails.activationTime = timeValue.replaceAll(":", "");
        requestOrderData.activationDetails.activationDate = CubiqTS.moment(
          model.goodFrom.dateValue,
          "DD-MMM-YYYY",
        )
          .format(this.DATE_FORMAT)
          .replace(/-/g, "");
        requestOrderData.activationDetails.timeAlias = model.goodFrom.marketValue;
        requestOrderData.activationDetails.timezone = model.goodFrom.timezoneValue;
      } else {
        errors.push(
          new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.GOOD_FROM, "format"),
        );
        goodFromFormatValid = false;
      }
    }

    // Populate good until
    let goodUntilFormatValid = true;
    let goodUntilValueValidForMarketOrder = true;
    let goodUntilSetButNotGTC =
      model.goodUntil != null &&
      model.goodUntil.marketValue != null &&
      model.goodUntil.marketValue != "GTC";
    let goodUntilIsNull = this.timeMachine.checkIfGoodFromUntilModelIsEmpty(model.goodUntil);

    if (goodUntilSetButNotGTC && this.isMarketOrder(model)) {
      errors.push(
        new OEInputModel(
          OENPanel.PANEL_FINANCIALS,
          OENInputControl.GOOD_UNTIL,
          "must_be_gtc_for_mkt",
        ),
      );
      goodUntilValueValidForMarketOrder = false;
    } else if (goodUntilSetButNotGTC) {
      if (!goodUntilIsNull && this.validator.validateExpiry(model.goodUntil)) {
        if (requestOrderData.expiryDetails == null) {
          requestOrderData.expiryDetails = new CubiqTS.ExpiryDetailsImpl();
        }
        requestOrderData.expiryDetails.expiryTime = model.goodUntil.timeValue;
        requestOrderData.expiryDetails.expiryDate = CubiqTS.moment(
          model.goodUntil.dateValue,
          "DD-MMM-YYYY",
        )
          .format(this.DATE_FORMAT)
          .replace(/-/g, "");
        requestOrderData.expiryDetails.timeAlias = model.goodUntil.marketValue;
        requestOrderData.expiryDetails.timezone = model.goodUntil.timezoneValue;
        requestOrderData.expiryDetails.dayOrder = model.goodUntil.dayOrder;
      } else {
        errors.push(
          new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.GOOD_UNTIL, "format"),
        );
        goodUntilFormatValid = false;
      }
    }

    if (goodUntilValueValidForMarketOrder) {
      // validate constraints
      let goodFromUntilConstraintsValid = true;
      if (
        goodFromSetButNotNOW &&
        goodUntilSetButNotGTC &&
        goodFromFormatValid &&
        goodUntilFormatValid
      ) {
        goodFromUntilConstraintsValid = this.validator.validateActivationExpiryConstraints(
          model.goodFrom,
          model.goodUntil,
          errors,
        );
      }

      // Validate Activation/Expiry ON-TIMEOUT constraint
      if (
        model.goodUntil != null &&
        !goodUntilIsNull &&
        goodUntilFormatValid &&
        goodFromUntilConstraintsValid
      ) {
        // if these are not valid, the error is already there no need to check timeout
        this.validator.validateExpiryTimeout(model.refId, model.goodUntil, errors);
      }
    }

    // OVERRIDE LOGIC
    // errors cleanup if order Lifespan is completed - fix for: OMS-24628
    if (model.isInTerminalState) {
      errors = this.deleteErrorsForElement(OENInputControl.GOOD_FROM, errors);
      errors = this.deleteErrorsForElement(OENInputControl.GOOD_UNTIL, errors);
    }
    /* ACTIVATION - EXPIRY VALIDATION - END */
  }

  /**********************************************************************/
  /* HELPERS - EXTRACT ALGO PARAMETERS  */
  // ALGO TYPE
  /**
   *
   * @param model
   * @param validateType When false, we will always return StrategyParameter
   * @param errors
   * @returns
   */
  protected extractAlgoType(
    model: OEDataModel,
    validateType: boolean,
    errors: Array<OEInputModel>,
  ): CubiqTS.StrategyParameterImpl {
    let value: CubiqTS.StrategyParameterImpl = null;
    if (this.isValidAlgoType(model.algoType) || !validateType) {
      let spAlgoType = new CubiqTS.StrategyParameterImpl();
      spAlgoType.parameterName = "StrategyName";
      spAlgoType.parameterType = 14;
      spAlgoType.parameterValue = model.algoType?.value;
      value = spAlgoType;
    } else {
      errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.ALGO_TYPE));
    }
    return value;
  }
  // LIMIT PRICE
  protected extractAlgoLimitPrice(model: OEDataModel, errors: Array<OEInputModel>): string {
    let value: string = null;
    if (this.isValidAlgoType(model.algoType)) {
      let algoTypeMode = this.atdlDataset.getLimitPriceMode(model.algoType.value);

      if (algoTypeMode !== ICDNAuxMode.DISABLED) {
        if (
          model.limitPrice instanceof ICLimitPriceModel &&
          model.limitPrice.mode !== ICDNAuxMode.DISABLED &&
          (model.limitPrice.mode === ICDNAuxMode.REQUIRED || model.limitPrice.activated) &&
          model.limitPrice.value instanceof CubiqTS.BigNumber &&
          model.limitPrice.value.isGreaterThan(0)
        ) {
          value = model.limitPrice.value.toFixed(this.lookup.ccyPairPrecision(model.ccyPair));
        } else if (
          model.limitPrice instanceof ICLimitPriceModel &&
          (model.limitPrice.mode === ICDNAuxMode.DISABLED ||
            (model.limitPrice.mode === ICDNAuxMode.OPTIONAL && !model.limitPrice.activated))
        ) {
          // VALID but not to be added to the request
        } else {
          errors.push(new OEInputModel(OENPanel.PANEL_FINANCIALS, OENInputControl.LIMIT_PRICE));
        }
      }
    }
    return value;
  }

  // Custom Fields
  /**
   * Check all custom values for editable fields and fail if any of the field constraints are broken
   * @param model
   * @param requestOrderData
   * @param errors
   */
  protected processCustomFields(
    model: OEDataModel,
    request: any,
    errors: Array<OEInputModel>,
  ): void {
    const isValid: boolean = this.validator.validateCustomFields(model);
    if (isValid) {
      request.customValues = model.customValues;
    } else {
      errors.push(new OEInputModel(OENPanel.PANEL_MORE, OENInputControl.CUSTOM_FIELDS));
    }
  }

  /* ALGO PARAMETERS  */
  protected extractAlgoParameters(
    model: OEDataModel,
    limitPrice: string | null,
    errors: Array<OEInputModel>,
  ): Array<CubiqTS.StrategyParameterImpl> {
    let valuesArray: Array<CubiqTS.StrategyParameterImpl> = null;
    // Algo Strategy Parameters
    if (
      model.algoParameters instanceof Array &&
      model.algoParameters.length > 0 &&
      this.validator.validateAlgoParameters(model, errors)
    ) {
      valuesArray = new Array<CubiqTS.StrategyParameterImpl>();
      for (let parameter of model.algoParameters) {
        if (parameter instanceof ATDLParameterDataModel) {
          // EXCLUDE: LimitPrice and AlgoName - hardcoded for now
          // deal with derived parameters => param has constValue reference or value
          if (
            typeof parameter.associatedIcdId === "string" &&
            parameter.associatedIcdId.length > 0
          ) {
            let associatedParam = model.algoParameters.find(
              (item) => item.icdId === parameter.associatedIcdId,
            );
            if (associatedParam != null && associatedParam.refName.toLowerCase() === "limitprice") {
              // skip limitPrice associated params
              parameter.value = limitPrice;
              // if below to be removed => checks ALGO_LIMIT_PRICE database value with ATDL strategy definition
              if (
                parameter.required &&
                model.limitPrice instanceof ICLimitPriceModel &&
                model.limitPrice.mode !== ICDNAuxMode.REQUIRED
              ) {
                logger.out.warn(
                  `WARNING: oeForwardAdapter.prepareOrderRequestData(): Algo Strategy Definition for LimitPrice inconsistent with DB: ATDL param: REQUIRED | DB value: ${
                    ICDNAuxMode[model.limitPrice.mode]
                  } `,
                );
                parameter.required = false;
              }
            } else if (associatedParam != null) {
              parameter.value = associatedParam.value;
            } else {
              parameter.value = parameter.constValue;
            }
          }
          // process parameter
          if (parameter.value != null) {
            let parameterImpl = new CubiqTS.StrategyParameterImpl();
            parameterImpl.parameterName = parameter.refName;
            parameterImpl.parameterType = parameter.fixType;
            // process value
            try {
              let value: string = this.processAlgoStrategyParameterValue(parameter, model);
              const priceError = this.getPriceValidationError(parameter, value);
              if (priceError) {
                errors.push(priceError);
                continue;
              }
              if (value != null) {
                parameterImpl.parameterValue = value;
                valuesArray.push(parameterImpl);
              } else if (value == null && parameter.required) {
                errors.push(
                  new OEInputModel(
                    OENPanel.PANEL_ALGO,
                    OENInputControl._ALGO_,
                    new ICDTransportModel(
                      parameter.icdId,
                      null,
                      `Parameter value INVALID for '${parameter.icdId}' even though is required!`,
                    ),
                  ),
                );
              }
            } catch (ex) {
              errors.push(
                new OEInputModel(
                  OENPanel.PANEL_ALGO,
                  OENInputControl._ALGO_,
                  new ICDTransportModel(parameter.icdId, null, ex.message),
                ),
              );
            }
          } else if (
            parameter.required &&
            (parameter.value == null ||
              (parameter.value instanceof ICDBaseModel && parameter.value.value == null))
          ) {
            errors.push(
              new OEInputModel(
                OENPanel.PANEL_ALGO,
                OENInputControl._ALGO_,
                new ICDTransportModel(
                  parameter.icdId,
                  null,
                  `Parameter value NULL for '${parameter.icdId}' even though is required!`,
                ),
              ),
            );
          }
        } else {
          logger.out.error(
            `${this.constructor.name}.extractAlgoParameters() parameter not an ATDLParameterDataModel`,
          );
        }
      }
    }
    return valuesArray;
  }

  public processAlgoParameters(
    model: OEDataModel,
    strategyParameters: CubiqTS.StrategyParameterImpl[],
    errors: Array<OEInputModel>,
  ): void {
    // Algo Strategy Parameters
    if (
      model.algoParameters instanceof Array &&
      model.algoParameters.length > 0 &&
      this.validator.validateAlgoParameters(model, errors)
    ) {
      for (let parameter of model.algoParameters) {
        if (parameter instanceof ATDLParameterDataModel) {
          // deal with derived parameters => param has constValue reference or value
          let associatedParam: ATDLParameterDataModel = null;
          if (
            typeof parameter.associatedIcdId === "string" &&
            parameter.associatedIcdId.length > 0
          ) {
            associatedParam = model.algoParameters.find(
              (item) => item.icdId === parameter.associatedIcdId,
            );

            if (associatedParam != null) {
              parameter.value = associatedParam.value;
            } else {
              parameter.value = parameter.constValue;
            }
          }

          // process parameter
          if (parameter.value != null) {
            let parameterImpl: CubiqTS.StrategyParameterImpl = strategyParameters.find(
              (param: CubiqTS.StrategyParameterImpl) => param.parameterName == parameter.refName,
            );

            if (parameterImpl == null) {
              parameterImpl = new CubiqTS.StrategyParameterImpl();
              strategyParameters.push(parameterImpl);
            }

            parameterImpl.parameterName = parameter.refName;
            parameterImpl.parameterType = parameter.fixType;

            // process value
            try {
              let value: string = this.processAlgoStrategyParameterValue(parameter, model);

              const priceError = this.getPriceValidationError(parameter, value);
              if (priceError) {
                errors.push(priceError);
                continue;
              }
              if (
                value == null &&
                associatedParam != null &&
                parameter.required &&
                !associatedParam.required
              ) {
                parameter.value = parameter.constValue;
                value = this.processAlgoStrategyParameterValue(parameter, model);
              }

              if (value != null) {
                parameterImpl.parameterValue = value;
              } else if (value == null && parameter.required) {
                errors.push(
                  new OEInputModel(
                    OENPanel.PANEL_ALGO,
                    OENInputControl._ALGO_,
                    new ICDTransportModel(
                      parameter.icdId,
                      null,
                      `Parameter value INVALID for '${parameter.icdId}' even though is required!`,
                    ),
                  ),
                );
              } else {
                strategyParameters.splice(strategyParameters.indexOf(parameterImpl), 1);
              }
            } catch (ex) {
              errors.push(
                new OEInputModel(
                  OENPanel.PANEL_ALGO,
                  OENInputControl._ALGO_,
                  new ICDTransportModel(parameter.icdId, null, ex.message),
                ),
              );
            }
          }
        }
      }
    }
  }

  /**
   * Checks a Price-type parameter to ensure that the string version of the parameter is still inside the parameter bounds
   * set for the parameter
   * @param parameter
   * @param value
   * @returns An error model if the string value is outside the min/max value bounds
   */
  private getPriceValidationError(
    parameter: ATDLParameterDataModel,
    value: number | string,
  ): OEInputModel {
    let retValue: OEInputModel = null;
    if (value && parameter.paramType === ATDLNParameterType.PRICE) {
      const enabledOrRequired =
        parameter.required == true ||
        (parameter.value != null &&
          parameter.value instanceof ICDSpinnerModel &&
          parameter.value.auxModel.enabled &&
          parameter.value.auxModel.value);
      const valueBig = new CubiqTS.BigNumber(value);
      if (parameter.minValue !== null && enabledOrRequired) {
        try {
          const minBig = new CubiqTS.BigNumber(parameter.minValue);

          if (valueBig.isLessThan(minBig)) {
            retValue = new OEInputModel(
              OENPanel.PANEL_ALGO,
              OENInputControl._ALGO_,
              new ICDTransportModel(
                parameter.icdId,
                null,
                // should translate this...
                `Parameter value '${parameter.icdId}' is less than min required!`,
              ),
            );
          }
        } catch (e) {
          logger.out.warn("Cannot resolve BigNUmber from Parameter", e);
        }
      }
      if (!retValue && parameter.maxValue !== null && enabledOrRequired) {
        try {
          const maxBig = new CubiqTS.BigNumber(parameter.maxValue);

          if (valueBig.isGreaterThan(maxBig)) {
            retValue = new OEInputModel(
              OENPanel.PANEL_ALGO,
              OENInputControl._ALGO_,
              new ICDTransportModel(
                parameter.icdId,
                null,
                // should translate this...
                `Parameter value '${parameter.icdId}' is greater than max required!`,
              ),
            );
          }
        } catch (e) {
          logger.out.warn("Cannot resolve BigNumber from Parameter", e);
        }
      }
    }
    return retValue;
  }

  private processAlgoStrategyParameterValue(
    parameter: ATDLParameterDataModel,
    model: OEDataModel,
  ): string {
    let throwError: boolean = false; // madafucking hack, proper way to do it is with a custom error class but I don't want to do it that way...
    try {
      if (parameter instanceof ATDLParameterDataModel && model instanceof OEDataModel) {
        let value: string = null;

        /// Simplify parameter value
        let paramValue = null;
        if (parameter.value == null) {
          return null;
        } else if (parameter.value instanceof ICDBaseModel && "value" in parameter.value) {
          /////////////////////////////////////////////////////// NULL CHECKs
          // return null if parameter value is null;
          if (parameter.value.value == null) {
            return null;
            // return null if parameter has Aux Checkbox and checkbox is not active;
          } else if (
            parameter.value.auxModel instanceof ICDAuxCheckboxModel &&
            parameter.value.auxModel.enabled &&
            !parameter.value.auxModel.value
          ) {
            return null;
          } else if (
            parameter.value.auxModel instanceof ICDAuxCheckboxModel &&
            parameter.value instanceof ICDBaseModel &&
            parameter.value.nulledByDependency === true
          ) {
            return null;
            /////////////////////////////////////////////////////// VALUE TRANSFORMATION
          } else if (parameter.value.value instanceof CubiqTS.BigNumber) {
            if (parameter.paramType === ATDLNParameterType.PRICE) {
              paramValue = parameter.value.value.toFixed(
                this.lookup.ccyPairPrecision(model.ccyPair),
              );
            } else {
              paramValue = parameter.value.value.toFixed();
            }
          } else if (
            parameter.dataset instanceof Array &&
            (parameter.value instanceof ICDAutocompleteModel ||
              parameter.value instanceof ICDRadioInputModel ||
              parameter.value instanceof ICDCheckboxModel)
          ) {
            const searchValue =
              parameter.value instanceof ICDCheckboxModel && parameter.value.enumRef
                ? parameter.value.enumRef
                : parameter.value.value;
            let dataItem = parameter.dataset.find((item) => item.enumId === searchValue);
            if (dataItem instanceof ATDLEnumModel && dataItem.wireValue != null) {
              paramValue = dataItem.wireValue;
            } else {
              throwError = true;
              throw new Error(`Invalid wire value for '${parameter.icdId}' ENUM model not found.`);
            }
          } else if (
            parameter.value instanceof ICDCheckboxModel &&
            parameter.checkedEnumRef &&
            parameter.uncheckedEnumRef
          ) {
            paramValue = parameter.value.value
              ? parameter.checkedEnumRef
              : parameter.uncheckedEnumRef;
          } else {
            paramValue = parameter.value.value;
          }
        } else if (parameter.value instanceof CubiqTS.BigNumber) {
          if (parameter.paramType === ATDLNParameterType.PRICE) {
            paramValue = parameter.value.toFixed(this.lookup.ccyPairPrecision(model.ccyPair));
          } else {
            paramValue = parameter.value.toFixed();
          }
        } else {
          paramValue = parameter.value;
        }

        // form this point on paramValue can not be null
        switch (parameter.paramType as number) {
          case -1:
            logger.out.error(
              `ERROR: oeForwardAdapter.processAlgoStrategyParameterValue(): UNSUPPORTED (FIX) parameter type ${
                ATDLNParameterType[parameter.paramType]
              } for '${parameter.icdId}'`,
            );
            return null;
          case ATDLNParameterType.BOOLEAN_FIX:
            const trueWireValue = parameter.trueWireValue ?? "Y";
            const falseWireValue = parameter.falseWireValue ?? "N";
            if (typeof paramValue === "boolean") {
              value = paramValue ? trueWireValue : falseWireValue;
            } else if (typeof paramValue === "string") {
              const upperValue = paramValue.toUpperCase();
              if (
                upperValue === "TRUE" ||
                upperValue === "FALSE" ||
                upperValue === "Y" ||
                upperValue === "N"
              ) {
                value =
                  paramValue === "TRUE" || paramValue === "Y" ? trueWireValue : falseWireValue;
              } else {
                throwError = true;
                throw new Error(
                  `Invalid parameter value: ${paramValue} for '${parameter.icdId}' with BOOLEAN_FIX param type.`,
                );
              }
            } else {
              throwError = true;
              throw new Error(
                `Invalid parameter type: ${typeof paramValue} for '${
                  parameter.icdId
                }' with BOOLEAN_FIX param type.`,
              );
            }
            break;
          case ATDLNParameterType.PERCENT:
            // if string convert to number for comparison
            if (typeof paramValue === "string") {
              paramValue = Number(paramValue);
            }
            // deal with the number
            if (typeof paramValue === "number") {
              /* if(paramValue >=0 && paramValue <= 1 && parameter.multiplyBy100){
                value = (paramValue * 100).toString();
              }else */
              if (paramValue >= 0 && paramValue <= 100) {
                paramValue = paramValue / 100;
                value = paramValue.toString();
              } else {
                throwError = true;
                throw new Error(
                  `Invalid parameter value: ${paramValue} for '${parameter.icdId}' with PERCENT param type.`,
                );
              }
            } else {
              throwError = true;
              throw new Error(
                `Invalid parameter value: ${paramValue} for '${parameter.icdId}' with PERCENT param type.`,
              );
            }
            break;
          case ATDLNParameterType.TZTIMEONLY:
            // Same as UTCTIMEONLY but handles additional Timezone specification
            if (typeof paramValue === "string" && ICD_TZ_CLOCK_TIME_PATTERN.test(paramValue)) {
              value = paramValue;
            } else {
              throw new Error(
                `Invalid parameter value: ${paramValue} for '${parameter.icdId}' with ${
                  ATDLNParameterType[parameter.paramType]
                } param type.`,
              );
            }
            break;
          case ATDLNParameterType.UTCTIMEONLY:
          case ATDLNParameterType.UTCTIMESTAMP:
            if (typeof paramValue === "string" && ICD_CLOCK_TIME_PATTERN.test(paramValue)) {
              value = paramValue;
            } else {
              throw new Error(
                `Invalid parameter value: ${paramValue} for '${parameter.icdId}' with ${
                  ATDLNParameterType[parameter.paramType]
                } param type.`,
              );
            }
            break;
          case ATDLNParameterType.TENOR:
          case ATDLNParameterType.MONTHYEAR:
          case ATDLNParameterType.DATE:
          case ATDLNParameterType.TZTIMESTAMP:
          case ATDLNParameterType.UTCDATEONLY:
            logger.out.error(
              `ERROR: oeForwardAdapter.processAlgoStartegyParameterValue(): UNHANDLED parameter type ${
                ATDLNParameterType[parameter.paramType]
              } for '${parameter.icdId}'`,
            );
            return null;
          //break;
          case ATDLNParameterType.PRICE:
          case ATDLNParameterType.PRICE_OFFSET:
          case ATDLNParameterType.FLOAT:
            if (typeof paramValue === "string") {
              let bigNumberParamValue = new CubiqTS.BigNumber(paramValue);
              value = bigNumberParamValue.toFixed(this.lookup.ccyPairPrecision(model.ccyPair));
            } else if (typeof paramValue === "number") {
              let bigNumberParamValue = new CubiqTS.BigNumber(paramValue);
              value = bigNumberParamValue.toFixed(this.lookup.ccyPairPrecision(model.ccyPair));
            } else {
              throwError = true;
              throw new Error(
                `Invalid parameter value: ${paramValue} for '${parameter.icdId}' with ${
                  ATDLNParameterType[parameter.paramType]
                } param type.`,
              );
            }
            break;
          case ATDLNParameterType.CHAR:
            if (typeof paramValue === "number") {
              paramValue = paramValue.toFixed();
            }

            if (typeof paramValue === "string" && paramValue.length === 1) {
              value = paramValue;
            } else {
              throwError = true;
              throw new Error(
                `Invalid parameter value '${paramValue}' for '${parameter.icdId}' with ${
                  ATDLNParameterType[parameter.paramType]
                } param type`,
              );
            }
            break;
          case ATDLNParameterType.AMT:
          case ATDLNParameterType.COUNTRY:
          case ATDLNParameterType.CURRENCY:
          //case ATDLNParameterType.DOUBLE:
          case ATDLNParameterType.EXCHANGE:
          case ATDLNParameterType.INT:
          case ATDLNParameterType.LANGUAGE:
          case ATDLNParameterType.LENGTH:
          case ATDLNParameterType.MULTICHAR:
          case ATDLNParameterType.MULTISTRING:
          case ATDLNParameterType.TAGNUM:
          case ATDLNParameterType.NUMGROUP:
          case ATDLNParameterType.QTY:
          case ATDLNParameterType.SEQNUM:
          case ATDLNParameterType.STRING:
            if (typeof paramValue === "string") {
              value = paramValue;
            } else if (typeof paramValue === "number") {
              value = paramValue.toString();
            } else {
              throwError = true;
              throw new Error(
                `Invalid parameter value '${paramValue}' for '${parameter.icdId}' with ${
                  ATDLNParameterType[parameter.paramType]
                } param type`,
              );
            }
            break;
          default:
            logger.out.error(
              `ERROR: oeForwardAdapter.processAlgoStrategyParameterValue(): UNKNOWN parameter type ${parameter.paramType} for '${parameter.icdId}'`,
            );
            return null;
        }
        return value;
      } else {
        logger.out.error(
          `ERROR: oeForwardAdapter.processAlgoStrategyParameterValue(): Invalid Parameter model or OE-Data model`,
        );
        return null;
      }
    } catch (ex) {
      if (throwError) {
        throw ex;
      } else {
        logger.out.error(
          `ERROR: oeForwardAdapter.processAlgoStrategyParameterValue(): Exception: ${ex}`,
        );
        return null;
      }
    }
  }

  /**********************************************************************/
  /* HELPERS - VALIDATION  */
  private isValidAlgoType(algoType: ICAutocompleteGenericModel): boolean {
    // could use Tradable set here instead to catch locally but story indicates should be server reject
    let algoTypeDataset = this.atdlDataset.getAllAlgosForAutoComplete();
    return (
      algoType instanceof ICAutocompleteGenericModel &&
      algoTypeDataset instanceof Array &&
      algoTypeDataset.map((item) => item.value).indexOf(algoType.value) >= 0
    );
  }

  private isDateOfValueDateInvalid(valueDate: ICTenorValueDateModel): boolean {
    if (valueDate != null && valueDate.tenor == null) {
      if (valueDate.valueDate) {
        valueDate.valueDate.setHours(0, 0, 0, 0);
        let now: Date = new Date();
        now.setHours(0, 0, 0, 0);
        if (valueDate.valueDate.valueOf() < now.valueOf()) {
          return true;
        }
      }
    }
    return false;
  }

  protected isValidMarkup(model: OEDataModel): boolean {
    let value: boolean = true;
    // Throw error if checkbox is selected and has no values
    if (model.markup !== null && model.markup instanceof ICMarkupModel) {
      if (
        model.markup.checkbox.value &&
        (model.markup.value == null ||
          model.markup.textValue == "" ||
          model.markup.typeValue == null)
      ) {
        value = false;
      }
    }
    return value;
  }

  protected isValidMarketOrderType(model: OEDataModel): boolean {
    // check system setting
    if (model instanceof OEDataModel && this.settings.areMarketOrdersEnabled()) {
      // check if client branch is mkt allowed
      if (
        (model.client instanceof CubiqTS.ClientImpl &&
          this.lookup.areMarketOrdersAllowedForClient(model.client)) ||
        model.isModificationPrivatized
      ) {
        // added due to OMS-36177
        // check if ccyPair is mkt enabled
        if (
          model.ccyPairModel instanceof CubiqTS.CurrencyPairImpl &&
          model.ccyPairModel.allowMarketOrdersFg
        ) {
          // check strategy constraints
          if (
            model.strategy == null ||
            (model.strategy instanceof OEStrategyModel &&
              (model.strategy.children == null ||
                (Array.isArray(model.strategy.children) && model.strategy.children.length == 0)) &&
              (model.strategy.siblings == null ||
                (Array.isArray(model.strategy.siblings) && model.strategy.siblings.length == 0)))
          ) {
            return true;
          }
        }
      }
    }
    return false;
  }

  /**********************************************************************/
  /* HELPERS - Debug Log - Extended logging  */
  private outputExtendedLogging(value: string, dump: any = null): void {
    this.oeLogger.outputExtendedLogging(value, dump);
  }
}
